import { Component, createRef } from 'react';
import { formatDate, formatAreaLabel } from '../../util';
import { serviceAreas } from '../../services/service-areas';
import { ServiceSupplier } from '../../services/service-supplier';
import services from '../../services';
import { regions } from '../../staticData/regions';

import { debounce } from 'lodash';
import MaterialTable from 'material-table';
import { createFilter } from 'react-select';
import { NotificationManager } from 'react-notifications';
import BtModal from '../../ts-components/bt-modal/bt-modal';
import AppAddArea from '../app-add-area/app-add-area';
import AppAddEditSupplier from '../app-add-supplier/app-add-supplier';
import SupplierDetailPanel from './supplier-detail-panel';
import { captureSupplierControls } from '../app-add-supplier/captureSupplierControls';
import AdApplicationDetailPanel from './ad-application-detail-panel';
import { tableIcons } from './icons';
import TableTopActions from './supplier-database-top-actions';
import { clearHandedOverTab, handedOverTab } from './handedOverTab';
import BlockIcon from '@material-ui/icons/Block';

import './dataTable.min.css';
import './app-supplier-database.css';
import './supplier-database-mini.css';
import { ServiceProjects } from '../../services/service-projects';
import moment from 'moment';
import _ from 'lodash';
import SelectedSupplierModule from './selected-supplier-module';
import OptionsMenu from '../../components/shared/OptionsMenu/OptionsMenu';
import appState from '../../state/AppStateContainer';
import SearchBarWithActions from '../../components/shared/SearchBarWithActions/SearchBarWithActions';
import Selector from '../../components/shared/Selector/Selector';
import TooltipContainer from '../../components/shared/TooltipContainer/TooltipContainer';
import { ContractIcon, CentralAgreementIcon } from '../../components/svgs';
import StyledCheckbox from '../../components/shared/StyledCheckbox/StyledCheckbox';
import StarRating from '../../components/shared/Rating';
import EvaluationRating from './EvaluationRating';
import { isMigratedRow } from '../../util/evaluationFormat';
import Field from '../../components/shared/Field/Field';
import BackButton from '../../components/shared/BackButton/BackButton';
import OverflowTip from '../../components/shared/OverflowTip/OverflowTip';
import PaginationWithGoTo from '../pagination-with-goto/pagination-with-goto';
import SupplierBlockedReasons from './supplier-blocked-reasons';
import AppLayout from '../../components/layout/app-layout/app-layout';
import SupplierAdPopUp from './SupplierAdPopUp/SupplierAdPopUp';
import { ServiceDashboard } from '../../services/service-dashboard';
import { AdApplicationStatus, AdApplicationType, PrequalificationDecision } from '../../util/appEnum';
import Modal from '../../components/shared/Modal/Modal';
import { serviceAdApplication } from '../../services/service-ad-application';
import { AdModal } from '../page-marketing/ad-modal';
import * as Sentry from '@sentry/react';
import BlockSupplierModal from './BlockSupplierModal';
import FloatingActionBar, { FloatingActionBarButton, FloatingActionBarDivider } from '../../components/shared/FloatingActionBar/FloatingActionBar';
import BulkDeleteSuppliersModal from './BulkDeleteSuppliersModal';
import BulkBlockSuppliersModal from './BulkBlockSuppliersModal';
import BulkManageCategoriesModal from './BulkManageCategoriesModal';
import CompareSuppliersModal from './CompareSuppliersModal';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import CategoryIcon from '@material-ui/icons/Category';
import ReplayIcon from '@material-ui/icons/Replay';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import serviceSupplierMonitoring from '../../services/service-supplier-monitoring';
import { ReactComponent as MonitoringIcon } from '../../assets/svg/monitor-icon.svg';
import { ReactComponent as ArrowStrokeDown } from '../../assets/svg/arrow_stroke_down.svg';
import { withTranslation, Trans } from 'react-i18next';
import i18n from '../../i18n';
import { placeOptions } from '../app-place-checklist/placeOptions';
import ArrowIcon from '../../components/svgs/arrowIcon';
import hasValidFile from '../../util/validFile';
import { buildNameList, retainAfterSupplierBulk, skippedIdsOf } from '../../util/supplierBulkOutcome';
import hasNoContactPersons, { upsertContactPerson } from '../../util/supplierContacts';
import ApproveAdModal from './ApproveAdModal';
import MissingContactPersonsModal from './MissingContactPersonsModal';
import { ReactComponent as TriangleWarningIcon } from '../../assets/svg/triangleWarningIcon.svg';
import app from '../../global/app';
import BtChecklistSelect from '../bt-checklist-select/bt-checklist-select';
import { QuickEvaluationModal } from '../app-evaluation-start';
import { countyValue, splitCountyPicks } from './countyChecklist';
import CountyMunicipalityChecklist from './CountyMunicipalityChecklist';

const pickedOptions = (values, picked, options) => values.map(value =>
  picked.find(option => option.value === value) ?? options.find(option => option.value === value));

// A stored pick the options lack, like a preset category before the areas load, keeps its stored label.
const withMissingPicks = (options, picked) => {
  const missing = picked.filter(pick => !options.some(option => option.value === pick.value));
  return missing.length ? [...options, ...missing] : options;
};

export const TabNames = Object.freeze({
  RECOMMENDED: 'RECOMMENDED',
  FEATURED: 'FEATURED',
  AD_APPLICATIONS: 'AD_APPLICATIONS',
});

const getSelectedTabName = (selectMode, selectedTab, isFeaturedSupplier) => {
  const isSuperAdminOrg = appState.isSuperAdminOrg();
  if (selectMode && selectedTab !== 0) {
    return TabNames.RECOMMENDED;
  }
  if (selectedTab === 3) {
    if (isFeaturedSupplier) return TabNames.FEATURED;
    if (isSuperAdminOrg) return TabNames.AD_APPLICATIONS;
  }
  return [
    PrequalificationDecision.APPROVED,
    PrequalificationDecision.INBOX,
    PrequalificationDecision.REJECTED
  ][selectedTab];
}

class SupplierDatabase extends Component {
  pagemounted = true;
  reopenDetailPanelRowId = null;

  constructor(props) {
    super(props);
    this.moveQueryParamToState();
    this.state = {
      ratingsDropdown: [
        { value: 1, label: <>{this.rating(1, true, true)}</> },
        { value: 2, label: <>{this.rating(2, true, true)}</> },
        { value: 3, label: <>{this.rating(3, true, true)}</> },
        { value: 4, label: <>{this.rating(4, true, true)}</> },
        { value: 5, label: <>{this.rating(5, true, true)}</> },
        { value: 'not rated yet', label: props.t('filter.rating.option.noRating', 'Inget betyg') },
      ],
      filterSearch: {
        searchFilter: props?.history?.location?.state?.q || '',
        areaId: props.areaUid ? [{ value: props.areaUid, label: props.areaName }] : [],
        municipality: [],
        county: [],
        places: [],
        rating: '',
        order: undefined,
        columns: [
          { data: '0', name: 'name' },
          { data: '1', name: 'area' },
          { data: '2', name: 'municipality' },
          { data: '3', name: 'places' },
        ],
        draw: '1',
        start: 0,
        multiFilter: [],
      },
      areas: [],
      cities: [],
      counties: {},
      places: [],
      data: [],
      isLoading: false,
      addUpdateSupplier: false,
      quickEvaluationSupplier: null,
      modalAddAreaShown: false,
      modalAddAreaKey: 0,
      modalAddAreaDataLoading: false,
      selectedSupplierIds: [],
      editSupplierData: [],
      quoteVersionsData: [],
      quoteVersion: null,
      extendedDate: undefined,
      contactPersons: [],
      selectedSuppliers: [],
      showMissingContactPersonsModal: false,
      currentPage: 1,
      errorMsg: '',
      addEditSupplierModalKey: 0,
      selectedTab: handedOverTab(props?.history?.location),
      bulkSelectedSupplierIds: [],
      bulkBlockedSupplierIds: [],
      // Full row objects for the current bulk selection, keyed by sup_id. Populated as rows are
      // (de)selected so a selection spanning multiple pages keeps the data of pages no longer
      // loaded — the FloatingActionBar/count already treats selection as cross-page; this makes
      // Compare (which needs more than an id) behave the same way.
      selectedSupplierRows: {},
      showCompareModal: false,
      compareRows: [],
      showBulkDeleteModal: false,
      showBulkBlockModal: false,
      showBulkUnblockModal: false,
      showBulkCategoriesModal: false,
      // True while a direct bulk action (approve/reject/reprocess) is in flight. Used to
      // lock the FloatingActionBar so a slow action can't be re-fired or stacked.
      // Temporary safeguard until step 6 (background jobs) replaces it.
      bulkActionRunning: false,
      numberOfRecommendedSuppliers: 0,
      showAdNotificationModal: false,
      showAdModal: false,
      submittingAd: false,
      selectedAdIndex: -1,
      blockModal: {
        show: false,
        key: 0,
        block: true,
        rowData: {},
      },
      rejectionReasonModalVisibility: false,
      rejectionReason: '',
      rejectApplicationModal: { show: false, supplierId: null, supplierName: '', rowData: null },
      rejectApplicationComment: '',
      expandedRowId: null,
      previousSuppliers: props.previousSuppliers || [],
      canRemoveSuppliers: props.canRemoveSuppliers || false,
    };
    this.tableRef = createRef();
    this.debouncedSearch = debounce(this.fetchSearchData, 1000);

    this.adTypesText = {
      [AdApplicationType.RECOMMENDED]: props.t('adApplication.adType.recommended', 'Rekommenderad leverantör'),
      [AdApplicationType.FEATURED]: props.t('adApplication.adType.featured', 'Annons på startsidan'),
    };
    this.adStatusText = {
      [AdApplicationStatus.PENDING]: props.t('adApplication.adStatus.pending', 'Pågående'),
      [AdApplicationStatus.REJECTED]: props.t('adApplication.adStatus.rejected', 'Nekade'),
    };
    this.featuredFilterOptions = [
      { value: 1, label: props.t('filter.featured.option.yes', 'Ja') },
      { value: 2, label: props.t('filter.featured.option.no', 'Nej') }
    ];
    this.applicationStatusOptions = [
      { value: 1, label: props.t('filter.applicationStatus.option.unanswered', 'Obesvarade') },
      { value: 2, label: props.t('filter.applicationStatus.option.rejected', 'Nekade') }
    ];
    this.multiFilterOptions = [
      { value: 'ue2021Form|1', label: this.props.t('filter.ue2021.option.with', 'With UE2021') },
      { value: 'ue2021Form|0', label: this.props.t('filter.ue2021.option.without', 'Without UE2021') },
      { value: 'liabilityInsurance|1', label: this.props.t('filter.liability.option.valid', 'With valid liability insurance') },
      { value: 'liabilityInsurance|-1', label: this.props.t('filter.liability.option.invalid', 'With invalid liability insurance') },
      { value: 'liabilityInsurance|0', label: this.props.t('filter.liability.option.no', 'No liability insurance') },
      { value: 'frameworkAgreement|1', label: this.props.t('filter.framework.option.valid', 'With valid framework agreement') },
      { value: 'frameworkAgreement|-1', label: this.props.t('filter.framework.option.invalid', 'With invalid framework agreement') },
      { value: 'frameworkAgreement|0', label: this.props.t('filter.framework.option.no', 'No framework agreement') },
      { value: 'isBlacklist|1', label: this.props.t('filter.blocked.option.onlyBlocked', 'Endast spärrade') },
      { value: 'isBlacklist|0', label: this.props.t('filter.blocked.option.hideBlocked', 'Göm spärrade') },
      { value: 'contactPersons|0', label: this.props.t('filter.contactPersons.option.without', 'Saknar kontaktpersoner') },
      { value: 'contactPersons|1', label: this.props.t('filter.contactPersons.option.with', 'Har kontaktpersoner') }
    ]
  }

  componentWillUnmount() {
    this.pagemounted = false;
  }

  componentDidMount() {
    clearHandedOverTab(this.props.history);
    const selectedTab = this.state.selectedTab;
    let filterData = this.state.filterSearch;
    const { areaUid, areaName, modifySuppName } = this.props;

    const pathParts = this.props.history?.location?.pathname?.split('/');
    const isFeatured = pathParts?.[3] === 'featured';
    const supplierId = pathParts?.[4];

    const isFeaturedSupplier = isFeatured && supplierId;

    const selectedTabName = getSelectedTabName(this.props.selectMode, selectedTab, isFeaturedSupplier);

    if (selectedTabName !== TabNames.AD_APPLICATIONS) {
      filterData.order = [{ column: '0', dir: 'asc' }];
      this.setState({ filterSearch: filterData });
    }

    if (modifySuppName) {
      this.handleChange(modifySuppName, 'searchFilter');
    } else {
      if (areaUid) {
        filterData.areaId = [{ value: areaUid, label: areaName }];
      }

      if (isFeaturedSupplier) {
        this.setState({ selectedTab: 3 });
        ServiceDashboard.getFeaturedSupplier(supplierId).then(featuredSupplier => {
          this.setState({ data: { data: [{ ...featuredSupplier }], page: 0, totalCount: 1, selectedTab: 3 } });
        });
      } else {
        const apiFilterData = {
          ...filterData,
          areaId: areaUid
        };
        this.fetchSuppliers(apiFilterData);
      }
    }

    this.fetchAdditionalData();

    if (this.props.previousSuppliers && this.props.previousSuppliers.length > 0) {
      const selectedSupplierIds = [];
      const selectedSuppliers = [];
      const contactPersons = [];

      this.props.previousSuppliers.forEach(supplier => {
        selectedSupplierIds.push(supplier.sup_id);
        selectedSuppliers.push(supplier);

        // Add default contact person if available
        if (supplier.supMember?.[0]) {
          const { supplierId, _id } = supplier.supMember[0];
          contactPersons.push({
            isCalled: false,
            isSeen: false,
            isSubmit: false,
            supplierId,
            supplierMemberId: _id,
            supplierMember: supplier.supMember[0],
          });
        }
      });

      this.setState({
        selectedSupplierIds,
        selectedSuppliers,
        contactPersons
      });

      if (this.props.selectEvent) {
        this.props.selectEvent(selectedSupplierIds);
      }
    }
  }

  componentDidUpdate() {
    const queryChanged = this.moveQueryParamToState();
    const q = this.props?.history?.location?.state?.q;
    if (q && queryChanged) {
      this.search(q);
      this.setState({ selectedTab: 0 });
    }
  }

  moveQueryParamToState = () => {
    const search = this.props?.history?.location?.search;
    if (search) {
      const pairs = search.substring(1).split('&').map(s => s.split('='));
      for (const pair of pairs) {
        if (pair[0] == 'q') {
          this.props.history.replace(this.props.history.location.pathname, { q: pair[1] });
          return true;
        }
      }
    }
    return false;
  }

  // The category the recommended-suppliers tab should suggest for. Normally the same category the
  // list is filtered to, but a caller can supply it separately when it deliberately shows an
  // unfiltered list (adding to several purchases at once) and would otherwise send no id at all —
  // ServiceSupplier.getRecommendedSuppliers interpolates it into the url, so undefined becomes the
  // literal string "undefined" and the endpoint answers with an empty list.
  recommendedAreaId = () => this.props.recommendedAreaId ?? this.props.areaUid;

  fetchAdditionalData = () => {
    this.fetchCities();
    this.fetchCounties();
    this.fetchPlaces();
    this.fetchAreas().then(() => {
      if (this.props.selectMode && this.props?.currentProject?.province) {
        ServiceSupplier.getRecommendedSuppliers(this.recommendedAreaId(), this.props?.currentProject?.province).then(recommendedSuppliers => {
          this.setState({ numberOfRecommendedSuppliers: recommendedSuppliers?.length, showAdNotificationModal: !appState.state.token.preferences.supplierAds?.preventPopUp && recommendedSuppliers?.length > 0 });
        });
      }
    });
    this.fetchQuotationVersion();
  };

  fetchQuotationVersion = async () => {
    const { realAreaId, selectMode, currentProject, t } = this.props;
    if (selectMode && currentProject) {
      const quoteVersionsData = await ServiceProjects.getVersionData(currentProject.slug, realAreaId);
      let versions = quoteVersionsData[0]?.versions || [];
      if (versions.length) {
        versions = versions.map(v => ({
          ...v,
          value: v.refVersion,
          label: t('selectMode.quotationVersion', 'Version {{versionNo}}', { versionNo: v.refVersion + 1 }),
        }));
        if (quoteVersionsData[0]) quoteVersionsData[0].versions = versions;
      }
      if (this.pagemounted) this.setState({ quoteVersionsData });
    }
  };

  rating = (rating, noNumber, readOnly) => (
    <StarRating className="rating-component gray-star" rating={rating} numberFirst={true} numberOfStars={1} readOnly={readOnly} fullSymbol="fa fa-star" />
  );

  resetFilter = () => {
    this.setState({
      filterSearch: {
        searchFilter: '',
        areaId: [],
        municipality: [],
        county: [],
        places: [],
        rating: '',
        order: [{ column: '0', dir: 'asc' }],
        featured: '',
        columns: [
          { data: '0', name: 'name' },
          { data: '1', name: 'area' },
          { data: '2', name: 'municipality' },
          { data: '3', name: 'places' },
        ],
      },
      selectedSupplierIds: [],
    });
  };

  getSupplierIds = () => this.state.selectedSupplierIds;

  toggleSort = colNum => {
    const { filterSearch } = this.state;
    const order = filterSearch.order?.[0] || {};
    if (order.column !== colNum) {
      order.column = colNum;
      order.dir = 'asc';
    } else if (order.dir === 'asc') {
      order.dir = 'desc';
    } else {
      order.dir = 'asc';
      order.column = '0';
    }
    this.handleChange([order], 'order');
  };

  async handleSupplierRowClick(rowData, selectedIds = this.state.selectedSupplierIds || []) {
    if (!rowData) return;

    const index = selectedIds.findIndex(s => s == rowData.sup_id);
    let newSupplierIds = [...selectedIds];
    let selectedSuppliers = [...this.state.selectedSuppliers];
    let contactPersons = [...this.state.contactPersons];

    if (index <= -1) {
      selectedSuppliers.push(rowData);
      newSupplierIds.push(rowData.sup_id);
      // add default contact person
      if (rowData.supMember?.[0] && !contactPersons.find(cp => cp.supplierId === rowData.sup_id)) {
        const { supplierId, _id } = rowData.supMember[0];
        contactPersons.push({
          isCalled: false,
          isSeen: false,
          isSubmit: false,
          supplierId,
          supplierMemberId: _id,
          supplierMember: rowData.supMember[0],
        });
      }
    } else {
      newSupplierIds.splice(index, 1);
      selectedSuppliers.splice(index, 1);
      // remove contact person
      contactPersons = contactPersons.filter(cp => cp.supplierId !== rowData.sup_id);
    }

    this.setState({ selectedSupplierIds: newSupplierIds, selectedSuppliers, contactPersons });
    if (this.props.selectEvent) this.props.selectEvent(newSupplierIds);
  }

  buildApiFilterData = (filters) => ({
    searchFilter: filters.searchFilter,
    areaId: Array.isArray(filters.areaId) ? filters.areaId.map(a => a.value) : [],
    municipality: Array.isArray(filters.municipality) ? filters.municipality.map(m => m.value) : [],
    county: Array.isArray(filters.county) ? filters.county.map(c => c.value) : [],
    places: Array.isArray(filters.places) ? filters.places.map(p => p.value) : [],
    rating: filters.rating,
    order: filters.order,
    columns: filters.columns,
    start: filters.start,
    featured: filters.featured,
    adStatus: filters.adStatus,
    adType: filters.adType,
    multiFilter: filters.multiFilter,
  });

  handleChange = (value, type, togglePage, argFilters) => {
    if (value == null) value = '';
    if (value == undefined && (['municipality', 'areaId', 'county', 'places', 'featured'].includes(type))) return;
    let { filterSearch } = this.state;
    const { selectMode } = this.props;
    let filters = argFilters || filterSearch;

    // A new filter, tab switch, or search invalidates any cross-page bulk selection.
    // Pagination passes type 'start' without togglePage, so the selection is preserved.
    if ((togglePage || type === 'searchFilter') && this.state.bulkSelectedSupplierIds.length) {
      this.setState({ bulkSelectedSupplierIds: [], bulkBlockedSupplierIds: [], selectedSupplierRows: {} });
    }

    if (type === 'multiFilter') {
      const multiFilter = filterSearch.multiFilter;
      const added = value.find(x => !multiFilter.find(y => y.value === x.value));

      if (added) {
        const hasToGetRemoved = multiFilter.find(x => x.value.includes(added.value.split('|')[0]));

        if (hasToGetRemoved) {
          value = value.filter(x => x.value !== hasToGetRemoved.value);
        }
      }
    }

    if (type === 'selectedTab') {
      this.setState({ selectedTab: value });
    } else if (type !== 'searchFilter') {
      filters[type] = value;
      this.setState({
        filterSearch: filters,
      });
    }

    let filterData = this.buildApiFilterData(filters);

    if (togglePage) {
      this.setState({
        currentPage: 1
      });
      filterData.start = 0;
    }

    this.fetchSuppliers(filterData);
  };

  // Kept per filter until its picks change: the checklist re-measures its chips on a new array.
  pickedValues = {};

  filterChecklist = (key, options) => {
    const picked = this.state.filterSearch[key];
    const listed = withMissingPicks(options, picked);
    if (this.pickedValues[key]?.picked !== picked) {
      this.pickedValues[key] = { picked, values: picked.map(option => option.value) };
    }
    return {
      options: listed,
      value: this.pickedValues[key].values,
      onChange: values => this.handleChange(pickedOptions(values, picked, listed), key, true),
    };
  };

  countyMunicipalityChecklist = () => {
    const { county, municipality } = this.state.filterSearch;
    const memo = this.pickedValues.countyMunicipality;
    if (memo?.county !== county || memo?.municipality !== municipality) {
      this.pickedValues.countyMunicipality = {
        county,
        municipality,
        values: [...county.map(pick => countyValue(pick.value)), ...municipality.map(pick => pick.value)],
      };
    }
    return {
      value: this.pickedValues.countyMunicipality.values,
      onChange: values => {
        const picks = splitCountyPicks(values);
        const toPick = value => ({ value });
        const county = picks.county.map(toPick);
        const municipality = picks.municipality.map(toPick);
        // Kept as handed over, since rebuilding from the two lists would put every county first.
        this.pickedValues.countyMunicipality = { county, municipality, values };
        this.handleChange(municipality, 'municipality', true, { ...this.state.filterSearch, county });
      },
    };
  };

  fetchAreas = async (_areasData) => {
    const areas = [];
    const areasData = _areasData || await serviceAreas.getAreas();
    areasData.forEach(item => areas.push({ label: formatAreaLabel(item.name, item.accountNumber), value: item._id }));

    if (this.pagemounted) this.setState({ areas });
    return areas;
  };

  fetchCities = async () => {
    await services.getCities().then(data => {
      if (this.pagemounted) {
        const cities = data.map(item => {
          const label = item === "Utomlands" ? "Utomlands / Other" : item;
          return { value: item, label: label };
        });
        this.setState({ cities })
      }
    });
  };

  fetchCounties = async () => {
    const counties = await services.getCitiesByCounty();
    if (this.pagemounted) this.setState({ counties });
  };

  fetchPlaces = async () => {
    if (this.pagemounted) this.setState({ places: placeOptions });
  };

  toggleLoader = (toggle = false) => {
    if (this.pagemounted) this.setState({ isLoading: toggle });
  }

  fetchAdApplications = async ({ status, type, search, sort, start }) => {
    const isFeaturedSupplier = (() => {
      const pathParts = this.props.history?.location?.pathname?.split('/');
      const isFeatured = pathParts?.[3] === 'featured';
      const supplierId = pathParts?.[4];

      return isFeatured && supplierId;
    })();

    const [{ data: adApplications, size }, areas] = await Promise.all([
      serviceAdApplication.fetchAdApplications({ status, type, search, sort, start }),
      serviceAreas.getAreas(true).then(this.fetchAreas),
    ]);

    const newSelectedTabName = getSelectedTabName(this.props.selectMode, this.state.selectedTab, isFeaturedSupplier);

    if (newSelectedTabName === TabNames.AD_APPLICATIONS) {
      this.setState({
        data: {
          data: adApplications.map(x => ({
            ...x,
            ...x.featuredInfo,
            ...x.application,
            ...x.recommendedInfo,
            areas: x.recommendedInfo.areas.map(area => areas.find(_area => _area.value == area)).filter(x => x),
            regions: x.recommendedInfo.regions.map(region => regions.find(_region => region === _region.label)),
            startDate: new Date(x.applicationType === AdApplicationType.RECOMMENDED ? x.recommendedInfo.startDate : x.featuredInfo.startDate)
          })), page: 0, totalCount: size
        },
        expandedRowId: null
      });
      this.toggleLoader(false);
    }
  }

  fetchSuppliers = async (sup = this.buildApiFilterData(this.state.filterSearch)) => {
    const { selectedTab } = this.state;
    this.toggleLoader(true);
    sup.mini = true;

    const isFeaturedSupplier = (() => {
      const pathParts = this.props.history?.location?.pathname?.split('/');
      const isFeatured = pathParts?.[3] === 'featured';
      const supplierId = pathParts?.[4];

      return isFeatured && supplierId;
    })();

    const selectedTabName = getSelectedTabName(this.props.selectMode, selectedTab, isFeaturedSupplier);

    if (selectedTabName !== TabNames.RECOMMENDED) {
      const supplierId = this.props.history?.location?.pathname?.split('/')?.[4];

      if (selectedTabName === TabNames.FEATURED) {
        const featuredSupplier = await ServiceDashboard.getFeaturedSupplier(supplierId);
        const newSelectedTabName = getSelectedTabName(this.props.selectMode, this.state.selectedTab, isFeaturedSupplier);
        if (newSelectedTabName === TabNames.FEATURED) {
          this.setState({ data: { data: [{ ...featuredSupplier }], page: 0, totalCount: 1 }, expandedRowId: null });
          this.toggleLoader(false);
        }
      } else if (selectedTabName === TabNames.AD_APPLICATIONS) {
        await this.fetchAdApplications({
          status: sup.adStatus,
          type: sup.adType,
          search: sup.searchFilter,
          sort: sup.order?.[0]?.column ? { column: sup.order[0].column, order: sup.order[0].dir } : undefined,
          start: sup.start,
        });
      } else {
        const data = await ServiceSupplier.fetchSupplier({
          ...sup,
          prequalification: [
            PrequalificationDecision.APPROVED,
            PrequalificationDecision.INBOX,
            PrequalificationDecision.REJECTED
          ][selectedTab]
        });

        const newSelectedTabName = getSelectedTabName(this.props.selectMode, this.state.selectedTab, isFeaturedSupplier);

        if (data.data && newSelectedTabName === selectedTabName) {
          let _data = { data: data.data, page: 0, totalCount: data.recordsFiltered };
          if (this.pagemounted) {
            this.setState({ data: _data, expandedRowId: null, evaluationsMigrated: !!data.evaluationsMigrated }, () => {
              if (this.reopenDetailPanelRowId) {
                const rowIdToReopen = this.reopenDetailPanelRowId;
                this.reopenDetailPanelRowId = null;
                this.reopenDetailPanel(rowIdToReopen);
              } else if (data.recordsFiltered === 1 &&
                sup.searchFilter &&
                sup.searchFilter.trim().length > 0 &&
                !this.props.selectMode) {
                this.autoOpenDetailsPanel();
              }
            });
          }
          appState.setSupplierApplicationCount(data.inboxCount);
          this.toggleLoader(false);
        }
      }
    } else {
      const recommendedSuppliers = await ServiceSupplier.getRecommendedSuppliers(this.recommendedAreaId(), this.props.currentProject?.province);
      const newSelectedTabName = getSelectedTabName(this.props.selectMode, this.state.selectedTab, isFeaturedSupplier);
      if (newSelectedTabName === selectedTabName) {
        this.setState({ data: { data: recommendedSuppliers.map(supplier => ({ ...supplier, isRecommended: true })), page: 0, totalCount: recommendedSuppliers.length }, expandedRowId: null });
        this.toggleLoader(false);
      }
    }
  };

  autoOpenDetailsPanel = () => {
    if (this.state.data?.data?.length === 1 && this.tableRef.current) {
      this.tableRef.current.onToggleDetailPanel([0], this.tableRef.current.props.detailPanel);
      this.setState({ expandedRowId: this.state.data.data[0].sup_id });
    }
  };

  reopenDetailPanel = (rowId) => {
    if (!rowId || !this.tableRef.current) return;
    const rows = this.state.data?.data || [];
    const index = rows.findIndex(r => (r.sup_id ?? r._id) === rowId);
    if (index > -1) {
      this.tableRef.current.onToggleDetailPanel([index], this.tableRef.current.props.detailPanel);
      this.setState({ expandedRowId: rowId });
    }
  };

  // *******EDIT SUPPLIER****************

  handleEdit = id => {
    const supplierProfile = this.state?.data?.data?.find(s => s.sup_id == id)?.supplierProfile;
    ServiceSupplier.getSupplieById(id).then(data => {
      this.updateEditSupplierData({ ...data, supplierProfile });
      this.setState(({ addEditSupplierModalKey }) => ({ addUpdateSupplier: true, addEditSupplierModalKey: addEditSupplierModalKey + 1 }));
    });
  };

  handleBlock = (rowData, block = false) => {
    this.setState({
      blockModal: {
        show: true,
        key: this.state.blockModal.key + 1,
        block,
        rowData,
      }
    });
  }

  updateEditSupplierData(data = []) {
    let formData = {
      name: '',
      supplierId: '',
      areaIds: [],
      organizationNumber: '',
      description: '',
    };

    if (data.length != 0) {
      formData.kommun = { label: data.kommun, value: data.kommun };
      formData.name = data.name;
      formData.city = data.city;
      formData.organizationNumber = data.organizationNumber;
      formData.vatNumber = data.vatNumber;
      formData.selectedIdentityField = data.selectedIdentityField;
      formData.website = data.website;
      formData.address = data.address;
      formData.isBlacklist = data.isBlacklist || false;
      formData.blacklistReason = data.blacklistReason || [];
      formData.description = data.description;
      formData.address = data.address;
      formData.postnumber = data.postnumber;
      formData.supplierId = data._id;
      formData.frameworkAgreements = data.frameworkAgreements;
      formData.liabilityInsurances = data.liabilityInsurances;
      formData.ue2021Forms = data.ue2021Forms;
      formData.otherFiles = data.otherFiles;
      formData.logo = data.logo;
      formData.ads = data.ads;
      formData.isFeatured = data.isFeatured;
      formData.featuredInfo = data.featuredInfo;
      formData.areaIds = data.areaIds.map((row) => row._id);
      formData.places = data.supplierProfile?.places?.length > 0 ? null : data.places;
      formData.supplierProfile = data.supplierProfile;
    }

    this.setState({ editSupplierData: formData });
  }

  // ***************************************

  handleDelete = supplierId => {
    if (window.confirm(this.props.t('deleteSupplier.confirm', 'Vill du ta bort leverantören?'))) {
      ServiceSupplier.deleteSupplier(supplierId).then(() => {
        this.setState(prev => {
          const selectedSupplierRows = { ...prev.selectedSupplierRows };
          delete selectedSupplierRows[supplierId];
          return {
            data: { ...prev.data, data: prev.data.data.filter(s => s.sup_id !== supplierId) },
            bulkSelectedSupplierIds: prev.bulkSelectedSupplierIds.filter(id => id !== supplierId),
            bulkBlockedSupplierIds: prev.bulkBlockedSupplierIds.filter(id => id !== supplierId),
            selectedSupplierRows,
          };
        });
      });
    }
  };

  handleMonitoring = async (supplierId, organizationNumber, isMonitored) => {
    const { t } = this.props;
    try {
      if (isMonitored) {
        const outcome = await serviceSupplierMonitoring.removeMonitoredSuppliers([organizationNumber,]);
        if (outcome.failed.length > 0) {
          NotificationManager.error(
            t('notification.error.supplierMonitoring.couldNotUnmonitor', 'Bevakningen kunde inte avslutas.'),
            t('notification.error.unexpected.title', 'Misslyckat')
          );
        } else {
          NotificationManager.success(
            t('notification.success.supplierMonitoring.description.unmonitored', 'Bevakning avslutad'),
            t('notification.success.supplierMonitoring.title', 'Sparat')
          );
        }
      } else {
        await serviceSupplierMonitoring.addMonitoredEntity({ supplierId, });
        NotificationManager.success(
          t('notification.success.supplierMonitoring.description.monitored', 'Leverantören bevakas'),
          t('notification.success.supplierMonitoring.title', 'Sparat')
        );
      }
      this.fetchSuppliers();
    } catch (error) {
      console.error(error);
      const errorMsg = _.get(error, 'response.data.error', t('notification.error.unexpected.description', 'Oväntat fel ({{error}})', { error }));
      NotificationManager.error(errorMsg, t('notification.error.unexpected.title', 'Misslyckat'));
      Sentry.captureException(error);
    }
  }

  // Evidence for the decision; a capture that fails must not block the decision itself.
  captureControlsSnapshot = async rowData => {
    if (!rowData) return undefined;
    try {
      const html = await captureSupplierControls({
        organizationNumber: rowData.organizationNumber,
        companyName: rowData.sup_name,
        hasSyna: !!rowData.hasSyna,
        hasCreditsafe: !!rowData.hasCreditsafe,
        hasTic: !!rowData.hasTic,
        history: this.props.history,
      });
      return html || undefined;
    } catch (e) {
      Sentry.captureException(e);
      return undefined;
    }
  };

  handleApprove = async (supplierId, rowData) => {
    const { t } = this.props;
    try {
      NotificationManager.info(t('notification.info.capturingSupplierControls', 'Hämtar leverantörskontroller…'));
      const supplierControlsHTML = await this.captureControlsSnapshot(rowData);
      await ServiceSupplier.approveSupplierApplication(supplierId, supplierControlsHTML);
      NotificationManager.success(
        t('notification.success.approveSupplierApplication.description', 'Glöm inte att meddela leverantören de goda nyheterna.'),
        t('notification.success.approveSupplierApplication.title', 'Ansökan godkänd')
      );
      this.fetchSuppliers();
    } catch (e) {
      const errorMsg = _.get(e, 'response.data.error', t('notification.error.unexpected.description', 'Oväntat fel'));
      NotificationManager.error(errorMsg, t('notification.error.unexpected.title', 'Fel'));
      Sentry.captureException(e);
    }
  }

  handleReject = (supplierId, rowData) => {
    this.setState({
      rejectApplicationModal: { show: true, supplierId, supplierName: rowData?.sup_name ?? '', rowData },
      rejectApplicationComment: '',
    });
  }

  confirmRejectApplication = async () => {
    const { t } = this.props;
    const { supplierId, rowData } = this.state.rejectApplicationModal;
    const comment = (this.state.rejectApplicationComment || '').trim();
    try {
      NotificationManager.info(t('notification.info.capturingSupplierControls', 'Hämtar leverantörskontroller…'));
      const supplierControlsHTML = await this.captureControlsSnapshot(rowData);
      await ServiceSupplier.rejectSupplierApplication(supplierId, supplierControlsHTML);
    } catch (e) {
      // The modal stays open with the typed reason intact, so a retry is one click.
      const errorMsg = _.get(e, 'response.data.error', t('notification.error.unexpected.description', 'Oväntat fel'));
      NotificationManager.error(errorMsg, t('notification.error.unexpected.title', 'Fel'));
      Sentry.captureException(e);
      return;
    }
    this.setState({
      rejectApplicationModal: { show: false, supplierId: null, supplierName: '', rowData: null },
      rejectApplicationComment: '',
    });
    let commentSaved = true;
    if (comment) {
      try {
        await ServiceSupplier.updateSupplierComments(supplierId, comment);
      } catch (e) {
        commentSaved = false;
        Sentry.captureException(e);
      }
    }
    NotificationManager.success(
      t('notification.success.rejectSupplierApplication.description', 'Leverantören kan inte ansöka igen så länge ansökan ligger kvar under nekade ansökningar.'),
      t('notification.success.rejectSupplierApplication.title', 'Ansökan nekad')
    );
    if (!commentSaved) {
      // The rejection committed — only the reason failed to reach the conversation.
      NotificationManager.warning(t('notification.warning.rejectCommentNotSaved', 'Ansökan nekades, men anledningen kunde inte sparas.'));
    }
    this.fetchSuppliers();
  }

  handleReprocess = async supplierId => {
    const { t } = this.props;
    try {
      await ServiceSupplier.reprocessSupplierApplication(supplierId);
      NotificationManager.success(
        t('notification.success.reprocessSupplierApplication.description', 'Leverantören flyttades till fliken ansökningar'),
        t('notification.success.reprocessSupplierApplication.title', 'Ansökan omstartad')
      );
      this.fetchSuppliers();
    } catch (e) {
      const errorMsg = _.get(e, 'response.data.error', t('notification.error.unexpected.description', 'Oväntat fel'));
      NotificationManager.error(errorMsg, t('notification.error.unexpected.title', 'Fel'));
      Sentry.captureException(e);
    }
  }

  // Inbox and Rejected rows are applications; a Featured or Recommended row is a register supplier only once it exists.
  isRegisterRow = rowData => {
    const selectedTabName = getSelectedTabName(this.props.selectMode, this.state.selectedTab);
    if (selectedTabName === PrequalificationDecision.APPROVED) return !rowData.isFeatured || !!rowData.exists;
    if ([PrequalificationDecision.INBOX, PrequalificationDecision.REJECTED].includes(selectedTabName)) return false;
    return !!((rowData.isFeatured || rowData.isRecommended) && rowData.exists);
  };

  openQuickEvaluation = supplier => this.setState({ quickEvaluationSupplier: supplier });

  evaluationOptions = (supId, rowData) => {
    const { t } = this.props;
    // The featured-supplier payload carries no marker, so only a list that says unmigrated hides them.
    if (this.props.selectMode || this.state.evaluationsMigrated === false || !this.isRegisterRow(rowData)) return [];
    const viewEvaluations = {
      label: t('register.viewEvaluations', { ns: 'evaluations', defaultValue: 'Visa utvärderingar' }),
      action: () => this.props.history.push(`${appState._getCurrentOrgUrl()}/supplier-database/evaluations/suppliers/${supId}`),
      icon: 'fa-chart-bar',
    };
    if (!appState.isWriteAccessRole()) return [viewEvaluations];
    return [
      {
        label: t('register.newEvaluation', { ns: 'evaluations', defaultValue: 'Ny utvärdering' }),
        action: () => this.openQuickEvaluation({ _id: supId, name: rowData.sup_name }),
        icon: 'fa-plus',
      },
      viewEvaluations,
    ];
  };

  renderActions = (supId, rowData) => {
    const { t } = this.props;
    const selectedTabName = getSelectedTabName(this.props.selectMode, this.state.selectedTab);
    if (appState.isClientRole()) return;
    if (selectedTabName == TabNames.RECOMMENDED && !rowData.exists) return;
    if (!appState.isSuperAdminOrg() && rowData.isFeatured && !rowData.exists) return;
    if (appState.isReadOnlyAccessRole()) {
      const readOnlyOptions = this.evaluationOptions(supId, rowData);
      return readOnlyOptions.length ? <OptionsMenu options={readOnlyOptions} /> : undefined;
    }

    const editSup = () => this.handleEdit(supId);
    const deleteSup = () => this.handleDelete(supId);

    const options = [
      { label: t('table.row.tools.edit', 'Redigera'), action: editSup, icon: 'fa-edit' },
    ];

    if (appState.isAdminRole()) {
      if (selectedTabName == PrequalificationDecision.APPROVED && rowData.organizationNumber && (rowData.hasSyna || rowData.hasCreditsafe)) {
        options.push({
          label: rowData.isMonitored ? t('table.row.tools.endMonitoring', 'Sluta bevaka leverantör') : t('table.row.tools.startMonitoring', 'Bevaka leverantör'),
          action: () => this.handleMonitoring(supId, rowData.organizationNumber, rowData.isMonitored),
          icon: <MonitoringIcon className='sup-db-opt-menu-monitoring-icon' style={{ marginRight: '8px' }} />
        });
      }

      options.push({
        label: rowData.isBlacklist ? t('table.row.tools.unblockSupplier', 'Ta bort spärr') : t('table.row.tools.blockSupplier', 'Spärra leverantör'),
        action: () => this.handleBlock(rowData, !rowData.isBlacklist),
        icon: 'fa-ban'
      });

      options.push({ label: t('table.row.tools.delete', 'Radera'), action: deleteSup, icon: 'fa-trash' });

      if (selectedTabName == PrequalificationDecision.INBOX) {
        options.push({ label: t('table.row.tools.approve', 'Godkänn ansökan'), action: () => this.handleApprove(supId, rowData), icon: 'fa-thumbs-up' });
        options.push({ label: t('table.row.tools.reject', 'Neka ansökan'), action: () => this.handleReject(supId, rowData), icon: 'fa-thumbs-down' });
      }

      if (rowData?.application && [PrequalificationDecision.REJECTED, PrequalificationDecision.APPROVED].includes(selectedTabName)) {
        options.push({ label: t('table.row.tools.reprocess', 'Gör om ansökan'), action: () => this.handleReprocess(supId), icon: 'fa-redo' });
      }
    }

    options.splice(1, 0, ...this.evaluationOptions(supId, rowData));

    return (
      <OptionsMenu options={options} />
    );
  };

  fetchSearchData = input => {
    this.handleChange(input, 'searchFilter');
  };


  resetExceptSearch = () => {
    const filterData = this.state.filterSearch;
    filterData.areaId = [];
    filterData.county = [];
    filterData.municipality = [];
    filterData.places = [];
    filterData.rating = '';
    filterData.featured = '';
    filterData.multiFilter = [];
    this.setState({ filterData });
  };

  search = (externalSearch) => {
    const filterData = this.state.filterSearch;
    filterData.searchFilter = externalSearch;
    this.setState({ currentPage: 1 });
    filterData.start = 0;
    this.setState({ filterData });
    this.debouncedSearch(externalSearch);
  };

  searchSamePage = () => {
    this.onPageChanged(this.state.currentPage)
  };

  saveSupplier = (result, check, isEditMode = false) => {
    const { data, selectedSuppliers, contactPersons } = this.state;
    if (result && isEditMode) {
      const item = data?.data?.find(s => s.sup_name === result.name);
      if (item) {
        item.reasons = result.blacklistReason;
        const selectedSupplierBeingEdited = selectedSuppliers?.find(s => s.sup_id === item.sup_id);
        if (selectedSupplierBeingEdited) {
          selectedSupplierBeingEdited.supMember = result.contacts;
        }
        const contactPerson = contactPersons?.find(contact => contact.supplierId === item.sup_id);
        if (contactPerson) {
          const foundNewContact = result.contacts.find(contact => contact._id === contactPerson.supplierMemberId);
          if (foundNewContact) {
            contactPerson.supplierMember = foundNewContact;
          } else {
            const newContact = result.contacts[0];
            contactPerson.supplierMemberId = newContact._id;
            contactPerson.supplierMember = newContact;
          }
        }
        this.setState({ data, selectedSuppliers, contactPersons });
      }
    }
    if (!check) {
      if (isEditMode) {
        this.reopenDetailPanelRowId = this.state.expandedRowId;
        this.searchSamePage();
      } else {
        this.resetExceptSearch();
        this.search(result.name);
      }
      this.toggleAddSupplierModal();
      if (result?.prequalification?.decision == PrequalificationDecision.INBOX) {
        this.setState({ selectedTab: 1 });
      }
    }
  };

  toggleAddSupplierModal = () => {
    this.setState(({ addUpdateSupplier, addEditSupplierModalKey }) => (
      { addUpdateSupplier: !addUpdateSupplier, addEditSupplierModalKey: addEditSupplierModalKey + 1 }
    ));
  };

  onAddSupplier = () => {
    this.updateEditSupplierData();
    this.toggleAddSupplierModal();
  };

  goToMonitoring = (subPath) => {
    this.props.history.push(`${appState._getCurrentOrgUrl()}/supplier-database${subPath}`);
  }

  // ========================== Add Area Start =============================

  goToAddAreaPage = () => {
    const orgSlug = appState.getCurrentOrgSlug();
    this.props.history.push({
      pathname: `/${orgSlug}/settings/categories`,
    });
  }

  handleAddAreaWithSuppliers = async (name, suppliersToAdd = [], accountNumber = '') => {
    const _data = this.state.data;
    let areas;
    this.setState({ modalAddAreaDataLoading: true });

    try {
      areas = await serviceAreas.addArea({ name, accountNumber: accountNumber || undefined });
      if (suppliersToAdd.length) {
        const area = areas.find(ar => ar.name === name);

        const promises = suppliersToAdd.map(supplierId => {
          const item = _data?.data.find(s => s.sup_id === supplierId);
          if (item) {
            item.area = item.area + ', ' + name;
          }
          return ServiceSupplier.addSupplierArea({ area: area._id, supplierId });
        });

        await Promise.all(promises);
      }
      await this.handleAddAreaWithSuppliersSuccess();
      this.setState({ modalAddAreaShown: false });
    } catch (error) {
      NotificationManager.error(this.props.t('notification.error.addSupplierArea', 'Något gick fel'));
    } finally {
      if (this.pagemounted) this.setState({ modalAddAreaDataLoading: false, data: _data });
    }
  };

  handleAddAreaWithSuppliersSuccess = async () => {
    NotificationManager.success(this.props.t('notification.success.addSupplierArea', 'Yrkeskategori tillagd'));
    // reload areas
    await this.fetchAreas();
    // reload mini datatable and close the modal
    if (this.appAddAreaInstance && this.pagemounted) this.appAddAreaInstance.resetState();
  };

  // ========================= Add Area End ================================

  customHeader = (title, colNum) => {
    const sortConfig = this.state.filterSearch.order?.[0];
    const isActive = sortConfig?.column === colNum;
    const ascending = sortConfig?.dir === 'asc';
    const titleClass = isActive ? 'sorted' : '';

    return (
      <div onClick={() => this.toggleSort(colNum)} className={`sup-db-title ${titleClass}`}>
        {title}
        {isActive && <ArrowStrokeDown style={{ width: '11px', transform: ascending ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'all 0.2s ease-in-out' }} />}
      </div>
    );
  };

  onPageChanged = currentPage => {
    this.setState({ currentPage });
    const pageOffset = (currentPage - 1) * 10;
    this.handleChange(pageOffset, 'start');
  };

  handleRowClick = (event, rowData, togglePanel) => {
    const rowId = rowData.sup_id ?? rowData._id;
    const currentExpandedId = this.state.expandedRowId;
    const newExpandedId = currentExpandedId === rowId ? null : rowId;
    this.setState({ expandedRowId: newExpandedId });
    togglePanel();
  };

  updateSupplierRowFromDetail = (supId, payload) => {
    const { data, selectedSuppliers, contactPersons } = this.state;
    const row = data?.data?.find(r => r.sup_id?.toString() === supId?.toString());
    if (!row) return;

    if (payload.contacts !== undefined) {
      row.supMember = payload.contacts;
      const sel = selectedSuppliers?.find(s => s.sup_id?.toString() === supId?.toString());
      if (sel) sel.supMember = payload.contacts;
      const contactPerson = contactPersons?.find(cp => cp.supplierId?.toString() === supId?.toString());
      if (contactPerson) {
        const updated = payload.contacts.find(c => c._id?.toString() === contactPerson.supplierMemberId?.toString());
        if (updated) contactPerson.supplierMember = updated;
        else if (payload.contacts.length > 0) {
          contactPerson.supplierMemberId = payload.contacts[0]._id;
          contactPerson.supplierMember = payload.contacts[0];
        }
      } else if (sel && payload.contacts.length > 0) {
        // The supplier was selected while it had no contact person, so selection never picked a
        // recipient for it. It has one now — fixing it from the detail panel is the whole point of
        // the warning, so the bid request has to start reaching it without re-selecting.
        contactPersons?.push({
          isCalled: false,
          isSeen: false,
          isSubmit: false,
          supplierId: payload.contacts[0].supplierId ?? sel.sup_id,
          supplierMemberId: payload.contacts[0]._id,
          supplierMember: payload.contacts[0],
        });
      }
    }
    if (payload.fileSections !== undefined) {
      if (payload.fileSections.frameworkAgreements !== undefined) row.frameworkAgreements = payload.fileSections.frameworkAgreements;
      if (payload.fileSections.liabilityInsurances !== undefined) row.liabilityInsurances = payload.fileSections.liabilityInsurances;
      if (payload.fileSections.ue2021Forms !== undefined) row.ue2021Forms = payload.fileSections.ue2021Forms;
      if (payload.fileSections.otherFiles !== undefined) row.otherFiles = payload.fileSections.otherFiles;
    }

    this.setState({ data: { ...data }, selectedSuppliers: selectedSuppliers ? [...selectedSuppliers] : [], contactPersons: contactPersons ? [...contactPersons] : [] });
  };

  onSelectionChange = (event, rowData) => {
    if (this.props.selectMode && (!rowData.isBlacklist || event === 'REMOVE')) {
      this.handleSupplierRowClick(rowData);
    }
  };

  toggleBulkSelect = (rowData) => {
    const supId = rowData.sup_id;
    const isBlacklist = rowData.isBlacklist;
    this.setState(prev => {
      const isRemoving = prev.bulkSelectedSupplierIds.includes(supId);
      const selectedSupplierRows = { ...prev.selectedSupplierRows };
      if (isRemoving) {
        delete selectedSupplierRows[supId];
      } else {
        // Cache the full row now, while it's still loaded — this is what lets Compare use it
        // later even if the user pages away before opening the modal.
        selectedSupplierRows[supId] = rowData;
      }
      return {
        bulkSelectedSupplierIds: isRemoving
          ? prev.bulkSelectedSupplierIds.filter(id => id !== supId)
          : [...prev.bulkSelectedSupplierIds, supId],
        // Track which selected suppliers are blocked, so block/unblock can target
        // the right subset of a mixed selection (cross-page aware).
        bulkBlockedSupplierIds: isRemoving
          ? prev.bulkBlockedSupplierIds.filter(id => id !== supId)
          : (isBlacklist ? [...prev.bulkBlockedSupplierIds, supId] : prev.bulkBlockedSupplierIds),
        selectedSupplierRows,
      };
    });
  };

  toggleBulkSelectAll = async () => {
    const { data, bulkSelectedSupplierIds, filterSearch, selectedTab } = this.state;
    const allSelected = bulkSelectedSupplierIds.length > 0 &&
      bulkSelectedSupplierIds.length === (data.totalCount || 0);
    if (allSelected) {
      this.clearBulkSelection();
      return;
    }
    try {
      // Send the same active filters the list endpoint uses, so the selected set
      // matches exactly what the table shows (and the count lines up with totalCount).
      const prequalificationByTab = {
        0: PrequalificationDecision.APPROVED,
        1: PrequalificationDecision.INBOX,
        2: PrequalificationDecision.REJECTED,
      };
      const prequalification = prequalificationByTab[selectedTab];
      const result = await ServiceSupplier.bulkGetAllIds({
        prequalification,
        searchFilter: filterSearch.searchFilter || undefined,
        areaId: Array.isArray(filterSearch.areaId) ? filterSearch.areaId.map(a => a.value) : undefined,
        municipality: Array.isArray(filterSearch.municipality) ? filterSearch.municipality.map(m => m.value) : undefined,
        county: Array.isArray(filterSearch.county) ? filterSearch.county.map(c => c.value) : undefined,
        places: Array.isArray(filterSearch.places) ? filterSearch.places.map(p => p.value) : undefined,
        rating: filterSearch.rating || undefined,
        featured: filterSearch.featured || undefined,
        multiFilter: filterSearch.multiFilter,
      });
      // "Select all" only returns ids, not full rows, for suppliers beyond this page — seed the
      // row cache with what's loaded now (merged with anything already cached) so Compare has as
      // much data as possible; rows never visited on their own page stay uncached (see the
      // partial-selection notice in openCompareModal).
      this.setState(prev => ({
        bulkSelectedSupplierIds: result.ids,
        bulkBlockedSupplierIds: result.blockedIds || [],
        selectedSupplierRows: {
          ...prev.selectedSupplierRows,
          ...Object.fromEntries((data.data || []).map(r => [r.sup_id, r])),
        },
      }));
    } catch (error) {
      // Fallback: select the current page only
      this.setState(prev => ({
        bulkSelectedSupplierIds: (data.data || []).map(r => r.sup_id),
        bulkBlockedSupplierIds: (data.data || []).filter(r => r.isBlacklist).map(r => r.sup_id),
        selectedSupplierRows: {
          ...prev.selectedSupplierRows,
          ...Object.fromEntries((data.data || []).map(r => [r.sup_id, r])),
        },
      }));
    }
  };

  clearBulkSelection = () => this.setState({ bulkSelectedSupplierIds: [], bulkBlockedSupplierIds: [], selectedSupplierRows: {} });

  // Selection persists across pagination (see handleChange), and the FloatingActionBar's count
  // already reflects that. Compare needs full row data, not just ids, so toggleBulkSelect caches
  // each selected row in selectedSupplierRows as it's (de)selected — that's what lets a selection
  // spanning multiple pages still produce full comparison data here. The one gap is "select all"
  // across pages never visited (see toggleBulkSelectAll): those ids have no cached row yet, so
  // they're excluded below and reported via the partial-selection notice.
  getCompareRows = () => {
    const { bulkSelectedSupplierIds, selectedSupplierRows } = this.state;
    return bulkSelectedSupplierIds.map(id => selectedSupplierRows[id]).filter(Boolean);
  };

  // Stable reference (unlike an inline arrow in JSX) — CompareSuppliersModal has an effect that
  // depends on this function; passing a fresh closure every render made that effect re-fire on
  // every parent render, not just when this modal's own state actually changed.
  setShowCompareModal = (v) => this.setState({ showCompareModal: v });

  openCompareModal = () => {
    const rows = this.getCompareRows();
    if (rows.length < 2) {
      NotificationManager.error(this.props.t('compare.notEnoughSelected', 'Markera minst två leverantörer för att jämföra.'));
      return;
    }
    if (rows.length < this.state.bulkSelectedSupplierIds.length) {
      NotificationManager.info(
        this.props.t(
          'compare.partialSelection',
          'Visar {{shown}} av {{total}} valda leverantörer – övriga saknar inläst data.',
          { shown: rows.length, total: this.state.bulkSelectedSupplierIds.length }
        )
      );
    }
    // Snapshot the rows once so the modal gets a stable array reference across parent re-renders
    // (getCompareRows() returns a fresh array each call; passing it inline would reset the modal's
    // removable-column state on every re-render).
    this.setState({ showCompareModal: true, compareRows: rows });
  };

  // Names for a subset of the current bulk selection, from the cached selected rows;
  // null when none of the ids have a cached row (see buildNameList on the cache gap).
  formatSupplierNames = (supplierIds) => {
    const { shown, more } = buildNameList(supplierIds, id => this.state.selectedSupplierRows[id]?.sup_name);
    if (!shown.length) return null;
    if (more > 0) {
      // `more`, not `count`, so i18next does not go looking for plural variants of the key.
      return `${shown.join(', ')} ${this.props.t('bulkActions.nameList.andMore', 'och {{more}} till', { more })}`;
    }
    return shown.join(', ');
  };

  handleBulkActionComplete = (outcome) => {
    // Retention is opt-in per action (outcome.retainSkipped): only block/unblock skips
    // belong to rows that can still render on this tab — a delete/decide/areas skip is a
    // row that left the view (deleted, or moved to another decision tab), and retaining
    // it would leave a phantom "N valda" bar with nothing visibly checked.
    const retained = outcome?.retainSkipped
      ? retainAfterSupplierBulk(outcome, this.state.bulkSelectedSupplierIds)
      : null;
    if (retained) {
      const keep = new Set(retained);
      this.setState(prev => ({
        bulkSelectedSupplierIds: prev.bulkSelectedSupplierIds.filter(id => keep.has(id)),
        // A block/unblock skip is proof the client's partition was wrong for that id
        // (the server's isBlacklist guard is why it was skipped) — reclassify instead
        // of keeping the stale bucket, or the bar would offer the same dead-end action.
        bulkBlockedSupplierIds: outcome.reclassify === 'block'
          ? [...retained]
          : outcome.reclassify === 'unblock'
            ? []
            : prev.bulkBlockedSupplierIds.filter(id => keep.has(id)),
        selectedSupplierRows: Object.fromEntries(Object.entries(prev.selectedSupplierRows).filter(([id]) => keep.has(id))),
      }));
    } else {
      this.clearBulkSelection();
    }
    if (!outcome || outcome.changed > 0) {
      // Reset to page 1 — bulk actions can reduce the total count enough that the
      // current page no longer exists, leaving the user on an empty table.
      this.onPageChanged(1);
    } else if (skippedIdsOf(outcome).length > 0) {
      // Nothing changed but something was skipped: the skip itself proves the table is
      // stale (the row changed server-side before the run), so refresh in place
      // without losing the user's page.
      this.onPageChanged(this.state.currentPage);
    }
  };

  handleBulkDecide = async (serviceCall, countOf, successMsg, successTitle, { captureControls = false } = {}) => {
    const { t } = this.props;
    const { bulkSelectedSupplierIds, bulkActionRunning, selectedSupplierRows } = this.state;
    // Guard against a double-fire while the previous request is still in flight.
    if (bulkActionRunning) return;
    this.setState({ bulkActionRunning: true });
    try {
      let supplierControlsHTML;
      if (captureControls) {
        NotificationManager.info(t('bulkActions.capturingSupplierControls', {
          count: bulkSelectedSupplierIds.length,
          defaultValue_one: 'Hämtar leverantörskontroller för {{count}} leverantör…',
          defaultValue_other: 'Hämtar leverantörskontroller för {{count}} leverantörer…',
        }));
        supplierControlsHTML = {};
        // One at a time: every capture is a full round of provider calls from this browser.
        for (const supplierId of bulkSelectedSupplierIds) {
          const html = await this.captureControlsSnapshot(selectedSupplierRows[supplierId]);
          if (html) supplierControlsHTML[supplierId] = html;
        }
      }
      const result = await serviceCall(bulkSelectedSupplierIds, supplierControlsHTML);
      const changed = countOf(result) ?? 0;
      const skippedIds = skippedIdsOf(result);
      if (changed > 0) {
        NotificationManager.success(successMsg(result), successTitle);
      }
      if (skippedIds.length > 0) {
        const names = this.formatSupplierNames(skippedIds);
        NotificationManager.info(names
          ? t('bulkActions.skipped.withNames', {
            count: skippedIds.length,
            names,
            defaultValue_one: '{{count}} leverantör hoppades över (redan hanterad eller borttagen): {{names}}',
            defaultValue_other: '{{count}} leverantörer hoppades över (redan hanterade eller borttagna): {{names}}',
          })
          : t('bulkActions.skipped.countOnly', {
            count: skippedIds.length,
            defaultValue_one: '{{count}} leverantör hoppades över (redan hanterad eller borttagen)',
            defaultValue_other: '{{count}} leverantörer hoppades över (redan hanterade eller borttagna)',
          }));
      }
      if (changed === 0 && skippedIds.length === 0) {
        NotificationManager.info(t('bulkActions.nothingChanged', 'Inga ändringar gjordes.'));
      }
      this.handleBulkActionComplete({ changed, skippedIds });
    } catch (e) {
      const errorKey = _.get(e, 'response.data.error');
      const errorMsg = errorKey === 'error.bulkWriteFailed'
        ? t('bulkActions.partialWrite', 'Något gick fel och vissa leverantörer kan ha uppdaterats. Ladda om sidan för att se vad som hände.')
        : errorKey ?? t('notification.error.unexpected.description', 'Oväntat fel');
      NotificationManager.error(errorMsg, t('notification.error.unexpected.title', 'Fel'));
      Sentry.captureException(e);
    } finally {
      this.setState({ bulkActionRunning: false });
    }
  };

  handleBulkApprove = () => this.handleBulkDecide(
    (ids, supplierControlsHTML) => ServiceSupplier.bulkApprove(ids, supplierControlsHTML),
    result => result.approved,
    result => this.props.t('bulkActions.approve.notification.success', '{{count}} leverantörer godkända', { count: result.approved }),
    this.props.t('bulkActions.approve.notification.title', 'Godkänt'),
    { captureControls: true },
  );

  handleBulkReject = () => this.handleBulkDecide(
    (ids, supplierControlsHTML) => ServiceSupplier.bulkReject(ids, supplierControlsHTML),
    result => result.rejected,
    result => this.props.t('bulkActions.reject.notification.success', '{{count}} leverantörer nekade', { count: result.rejected }),
    this.props.t('bulkActions.reject.notification.title', 'Nekat'),
    { captureControls: true },
  );

  handleBulkReprocess = () => this.handleBulkDecide(
    ids => ServiceSupplier.bulkReprocess(ids),
    result => result.reprocessed,
    result => this.props.t('bulkActions.reprocess.notification.success', '{{count}} ansökningar flyttade till inkorgen', { count: result.reprocessed }),
    this.props.t('bulkActions.reprocess.notification.title', 'Omstartade')
  );

  // Per supplier, never per contact person: the question is only whether anything can be sent to
  // this company at all.
  renderMissingContactPersonsBadge = rowData => {
    const { t } = this.props;
    if (!hasNoContactPersons(rowData.supMember)) return null;

    return (
      <span className="sup-missing-contacts-badge" onClick={e => e.stopPropagation()}>
        <TooltipContainer renderReferenceComponent={(className, ref) => (
          <span className={className} ref={ref}>
            <TriangleWarningIcon className="sup-missing-contacts-badge-icon" />
          </span>
        )}>
          <div style={{ maxWidth: '300px', fontSize: '14px', color: 'var(--gray-700)', fontWeight: 400 }}>
            {t(
              'table.row.missingContactPersons.tooltip',
              'Leverantören har ingen kontaktperson. Den kan läggas till i upphandlingen, men inget förfrågningsunderlag kan skickas till den förrän en kontaktperson finns.'
            )}
          </div>
        </TooltipContainer>
      </span>
    );
  };

  getColumns = (isFeaturedSupplier) => {
    const { selectedTab, evaluationsMigrated } = this.state;
    const { t } = this.props;
    const scoreHeader = (migratedTitle, legacyTitle) => {
      if (evaluationsMigrated === undefined) return '';
      return evaluationsMigrated ? migratedTitle : legacyTitle;
    };

    let isAdApplicationTab = false;
    if (!this.props.selectMode && appState.isSuperAdminOrg()) {
      isAdApplicationTab = isFeaturedSupplier ? selectedTab === 4 : selectedTab === 3;
    }

    const columns = isAdApplicationTab ? [
      {
        title: this.customHeader(t('table.header.organizationNumber', 'Organisationsnummer'), '0'),
        cellStyle: { fontSize: null },
        render: (rowData) => (
          <div className="sp-first-col">
            <ArrowIcon className={`sp-db-arrow-icon ${this.state.expandedRowId === rowData._id ? 'sp-db-arrow-icon--down' : ''}`} />
            <span style={{ color: 'var(--gray-900)', fontWeight: 500 }}>{rowData.companyName} <span style={{ color: 'var(--gray-500)', fontWeight: 400 }}>{rowData.organizationNumber}</span></span>
          </div>
        ),
      },
      {
        title: this.customHeader(t('table.header.adType', 'Typ'), '1'),
        cellStyle: { fontSize: null },
        render: (rowData) => <span>{this.adTypesText[rowData.applicationType]}</span>,
      },
      {
        title: this.customHeader(t('table.header.adStatus', 'Status'), '2'),
        cellStyle: { fontSize: null },
        render: (rowData) => <span>{this.adStatusText[rowData.status]}</span>,
      },
      {
        title: this.customHeader(t('table.header.createdBy', 'Skapad av'), '3'),
        cellStyle: { fontSize: null },
        render: (rowData) => <span>{rowData.applicant?.name} ({rowData.applicant?.email})</span>,
      },
      {
        title: this.customHeader(t('table.header.createdAt', 'Ansökningsdatum'), '4'),
        cellStyle: { fontSize: null },
        render: (rowData) => <span>{formatDate(rowData.createdAt)}</span>,
      },
      {
        title: '',
        cellStyle: { fontSize: null },
        render: (rowData) => {
          const options = [
            {
              label: t('table.row.tools.edit', 'Redigera'),
              action: () => this.setState({ selectedAdIndex: rowData.tableData.id, showAdModal: true }),
              icon: 'fa-edit',
            },
          ];
          if (rowData.status === AdApplicationStatus.PENDING) {
            options.push({
              label: t('table.row.tools.approve', 'Godkänn ansökan'), action: () => {
                if (rowData.applicationType === AdApplicationType.RECOMMENDED) {
                  this.setState({ approveAdModalVisibility: true, selectedAdIndex: rowData.tableData.id });
                } else {
                  this.updateAdStatus(rowData._id, AdApplicationStatus.APPROVED);
                }
              }, icon: 'fa-thumbs-up'
            });
            options.push({
              label: t('table.row.tools.reject', 'Neka ansökan'), action: () => {
                this.setState({ rejectionReasonModalVisibility: true, selectedAdIndex: rowData.tableData.id });
              }, icon: 'fa-thumbs-down'
            });
          } else if (rowData.status === AdApplicationStatus.REJECTED) {
            options.push({
              label: t('table.row.tools.reprocessApplication', 'Gör om ansökan'), action: () => {
                this.updateAdStatus(rowData._id, AdApplicationStatus.PENDING);
              }, icon: 'fa-redo'
            });
          }
          options.push({
            label: t('table.row.tools.delete', 'Radera'), action: async () => {
              await serviceAdApplication.deleteAdApplication(rowData._id);
              await this.fetchAdApplications({
                status: this.state.filterSearch.adStatus,
                type: this.state.filterSearch.adType,
                search: this.state.filterSearch.searchFilter,
                sort: this.state.filterSearch.order?.[0]?.column ? { column: this.state.filterSearch.order[0].column, order: this.state.filterSearch.order[0].dir } : undefined,
                start: this.state.filterSearch.start,
              });
            }, icon: 'fa-trash'
          });

          return (
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div onClick={e => e.stopPropagation()}>
                <OptionsMenu options={options} />
              </div>
            </div>
          )
        }
      }
    ] : [
      {
        title: (
          <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {!this.props.selectMode && ((selectedTab === 0 && appState.isWriteAccessRole()) || (selectedTab === 1 && appState.isAdminRole()) || (selectedTab === 2 && appState.isAdminRole())) && (
              <span onClick={e => e.stopPropagation()}>
                <StyledCheckbox
                  checked={this.state.bulkSelectedSupplierIds.length > 0 && this.state.bulkSelectedSupplierIds.length === (this.state.data.totalCount || 0)}
                  dash={this.state.bulkSelectedSupplierIds.length > 0 && this.state.bulkSelectedSupplierIds.length < (this.state.data.totalCount || 0)}
                  onChange={this.toggleBulkSelectAll}
                />
              </span>
            )}
            {this.customHeader(t('table.header.companyName', 'Företagsnamn'), '0')}
          </span>
        ),
        sorting: true,
        cellStyle: { fontSize: null, paddingLeft: this.props.selectMode ? '0px' : null },
        render: rowData => {
          const validFrameworkAgreement = hasValidFile(rowData.frameworkAgreements ?? []);
          let active = false;
          let end;
          const pickedDate = validFrameworkAgreement?.validUntilDate;
          if (pickedDate) {
            end = new Date(pickedDate);
            end.setHours(23, 59, 59, 999);
            active = new Date() < end;
          }
          const color = active ? 'var(--green-500)' : 'var(--red-300)';
          return (
            <div className="sp-first-col">
              {!this.props.selectMode && ((selectedTab === 0 && appState.isWriteAccessRole()) || (selectedTab === 1 && appState.isAdminRole()) || (selectedTab === 2 && appState.isAdminRole())) && (
                <span onClick={e => e.stopPropagation()}>
                  <StyledCheckbox
                    checked={this.state.bulkSelectedSupplierIds.includes(rowData.sup_id)}
                    onChange={() => this.toggleBulkSelect(rowData)}
                  />
                </span>
              )}
              <ArrowIcon className={`sp-db-arrow-icon ${this.state.expandedRowId === rowData.sup_id ? 'sp-db-arrow-icon--down' : ''}`} />
              {rowData.isBlacklist && (
                <span className="blacklistWarningHover">
                  <TooltipContainer renderReferenceComponent={(className, ref) => <BlockIcon style={{ marginRight: '10px' }} className={className} innerRef={ref} />}>
                    {rowData.reasons?.length > 0 && (
                      <div style={{ maxWidth: '300px' }}>
                        <SupplierBlockedReasons reasons={rowData.reasons} />
                      </div>
                    )}
                  </TooltipContainer>
                </span>
              )}
              {(validFrameworkAgreement?.file || validFrameworkAgreement?.validUntilDate || validFrameworkAgreement?.comment) &&
                <ContractIcon style={{ marginRight: '10px', marginLeft: '0', flexShrink: 0 }} color={validFrameworkAgreement?.validUntilDate ? color : 'var(--green-500)'} />
              }
              {rowData.centralAgreements?.length > 0 &&
                <TooltipContainer renderReferenceComponent={
                  (className, ref) => <CentralAgreementIcon color="var(--orange-500)" style={{ marginRight: '10px', marginLeft: '0', flexShrink: 0 }} className={className} innerRef={ref} />
                }>
                  <div style={{ maxWidth: '300px', fontSize: '14px', color: 'var(--gray-700)', fontWeight: 400 }}>
                    {t('table.row.centralAgreementInfo', 'Detta centralt upphandlade ramavtal tillhandahålls av Accurator i samarbete med vår partner Procava.')}
                  </div>
                </TooltipContainer>
              }
              <div className="sup-db-tab-val" title={rowData.sup_name}>
                {rowData.sup_name}
              </div>
              {this.props.selectMode && this.renderMissingContactPersonsBadge(rowData)}
            </div>
          )
        },
      },
      {
        title: this.customHeader(t('table.header.area', 'Yrkesområde'), '1'),
        cellStyle: { fontSize: null },
        render: rowData => <OverflowTip content={[...(rowData.areaArray ?? [])].sort((a, b) => a.name.localeCompare(b.name, 'sv')).map(a => formatAreaLabel(a.name, a.accountNumber))} />
      },
      {
        title: this.customHeader(t('table.header.municipality', 'Kommun'), '2'),
        cellStyle: { fontSize: null },
        render: rowData => {
          const city = this.state.cities.find(c => c.value === rowData.city);
          return <span>{city?.label || rowData.city}</span>;
        }

      },
      {
        title: this.customHeader(t('supplierDetailPanel.profileInfo.places.title', 'Verksamhetsområden'), '3'),
        cellStyle: { fontSize: null },
        render: rowData => {
          const supId = rowData.exists && rowData.existingSupplierId ? rowData.existingSupplierId : rowData.sup_id;
          return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <OverflowTip content={(rowData.supplierProfile?.places?.length > 0 ? rowData.supplierProfile?.places ?? [] : rowData.places ?? []).map(p => placeOptions.find(o => o.value === p)?.label ?? p)} />
            {selectedTab !== 0 && this.renderActions(supId, rowData)}
          </div>
        }
      },
      {
        title: scoreHeader(
          t('supplierScore.label', { ns: 'evaluations', defaultValue: 'Betyg' }),
          t('table.header.rating', 'Rekommendationer'),
        ),
        cellStyle: { fontSize: null },
        render: row => {
          if (isMigratedRow(row)) return <EvaluationRating rating={row.rating} evaluationCount={row.evaluationCount} />;
          return this.rating(row.rating ?? 0, false, true);
        },
        hidden: selectedTab !== 0
      },
      {
        disableClick: true,
        title: scoreHeader(
          t('supplierScore.evaluatedProjects', { ns: 'evaluations', defaultValue: 'Utvärderade projekt' }),
          t('table.header.projectsCount', 'Antal Projekt'),
        ),
        cellStyle: { fontSize: null },
        render: rowData => {
          const supId = rowData.sup_id;
          return (
            <div className="sp-action-wrapper">
              <div className="sp-action-num-icon">
                <div className='projects-count'>{rowData.projectsCount || 0}</div>
              </div>
              {this.renderActions(supId, rowData)}
            </div>
          )

        },
        hidden: selectedTab !== 0
      }
    ];

    return columns;
  };

  handleQuoteExpiry = expDate => {
    const { quoteVersion } = this.state;
    let extendedDate = new Date(expDate);
    quoteVersion.quotationExpiryDate = extendedDate;
    this.setState({ extendedDate, errorMsg: '' });
  };

  onToggleQuotation = quotationToggle => {
    let extendedDate = this.state.extendedDate;
    let quoteVersion = null;
    let contactPersons = this.state.contactPersons;
    if (quotationToggle) {
      const { quoteVersionsData = [] } = this.state;
      const quoteVersions = _.cloneDeep(quoteVersionsData[0]?.versions);
      contactPersons = this.initiateDefaultContactPerson();
      quoteVersion = quoteVersions[quoteVersions.length - 1];
      extendedDate = extendedDate || (quoteVersion.quotationExpiryDate ? new Date(quoteVersion.quotationExpiryDate) : null);
    }
    this.setState({ quoteVersion, contactPersons, extendedDate });
  };

  initiateDefaultContactPerson = () => {
    const { contactPersons, selectedSuppliers } = this.state;
    let contactPersonsArray = contactPersons;
    if (selectedSuppliers?.length) {
      selectedSuppliers.map(sup => {
        if (sup.supMember?.[0] && !contactPersonsArray.find(cp => cp.supplierId === sup.sup_id)) {
          const { supplierId, _id } = sup.supMember[0];
          contactPersonsArray.push({
            isCalled: false,
            isSeen: false,
            isSubmit: false,
            supplierId,
            supplierMemberId: _id,
            supplierMember: sup.supMember[0],
          });
        }
      });
    }
    return contactPersonsArray.filter(cp => selectedSuppliers.find(supplier => supplier.sup_id === cp.supplierId));
  };

  /** Selected suppliers that no bid request can reach. Per supplier, not per contact person. */
  suppliersMissingContactPersons = () =>
    (this.state.selectedSuppliers || []).filter(sup => hasNoContactPersons(sup.supMember));

  /** True when saving would also send the latest bid request (the auto-send toggle is on). */
  isSendingBidRequest = () => !!this.state.quoteVersion;

  onSaveSelectedSuppliersClick = () => {
    const { t } = this.props;
    const { quoteVersion, extendedDate, contactPersons } = this.state;

    if (
      quoteVersion &&
      extendedDate &&
      this.checkQuotationExpiry(moment(extendedDate).endOf('day').utc()) &&
      contactPersons?.length
    ) {
      this.setState({ errorMsg: t('selectMode.errorMessage.quotationExpiryMissing', 'Välj utgångsdatum') });
      return;
    }

    // Confirm rather than block: the suppliers are still added, they just can't be sent to.
    if (this.props.confirmMissingContactPersons && this.suppliersMissingContactPersons().length) {
      this.setState({ showMissingContactPersonsModal: true });
      return;
    }

    this.props.onSaveSelectedSuppliersClick();
  };

  isDateExpired = endDate => moment.utc().isAfter(endDate);

  checkQuotationExpiry = (expDate = null) => {
    const { quoteVersionsData } = this.state;
    const quoteVersions = quoteVersionsData[0]?.versions;
    let latestQuoteVersions = quoteVersions?.length && quoteVersions[quoteVersions.length - 1];
    return latestQuoteVersions && this.isDateExpired(expDate || latestQuoteVersions.quotationExpiryDate);
  };

  onSelectContactPerson = cp => {
    this.setState({ contactPersons: upsertContactPerson(this.state.contactPersons, cp) });
  };

  updateAdStatus = async (id, status, rejectionReason) => {
    if (!id) return;
    const { t } = this.props;

    this.setState({ submittingAd: true });

    const data = { status };

    if (status === AdApplicationStatus.REJECTED) {
      data.rejectionReason = rejectionReason;
    }

    try {
      await serviceAdApplication.updateAdApplicationStatus(id, data);
      await this.fetchAdApplications({
        status: this.state.filterSearch.adStatus,
        type: this.state.filterSearch.adType,
        search: this.state.filterSearch.searchFilter,
        sort: this.state.filterSearch.order?.[0]?.column ? { column: this.state.filterSearch.order[0].column, order: this.state.filterSearch.order[0].dir } : undefined,
        start: this.state.filterSearch.start,
      });
      this.setState({ showAdModal: false, selectedAdIndex: -1, rejectionReason: '', rejectionReasonModalVisibility: false, });
      NotificationManager.success(
        t('notification.success.submitApplication.description', 'Ansökan har lämnats'),
        t('notification.success.submitApplication.title', 'Ansökt')
      );
    } catch (error) {
      const errorMsg = _.get(error, 'response.data.error', t('notification.error.unexpected.description', 'Oväntat fel ({{error}})', { error }));
      NotificationManager.error(errorMsg, t('notification.error.unexpected.title', 'Misslyckat'));
      Sentry.captureException(error);
    } finally {
      this.setState({ submittingAd: false });
    }
  }

  submitRecommendedSupplierAd = async (adApplication) => {
    const { t } = this.props;
    try {
      await serviceAdApplication.updateRecommendedAdApplication(adApplication?._id, {
        ad: {
          startDate: adApplication?.startDate,
          regions: (adApplication?.regions ?? []).map(x => x?.value ?? '').filter(x => x),
          areas: (adApplication?.areas ?? []).map(x => x?.value ?? '').filter(x => x),
        },
        invoiceInterval: adApplication?.invoiceInterval,
        invoiceEmail: adApplication?.invoiceEmail,
        invoiceRef: adApplication?.invoiceRef,
      });
      this.setState({ showAdModal: false });
      await this.fetchAdApplications({
        status: this.state.filterSearch.adStatus,
        type: this.state.filterSearch.adType,
        search: this.state.filterSearch.searchFilter,
        sort: this.state.filterSearch.order?.[0]?.column ? { column: this.state.filterSearch.order[0].column, order: this.state.filterSearch.order[0].dir } : undefined,
        start: this.state.filterSearch.start,
      });

      NotificationManager.success(
        t('notification.success.submitApplication.description', 'Ansökan har lämnats'),
        t('notification.success.submitApplication.title', 'Ansökt')
      );
    } catch (error) {
      const errorMsg = _.get(error, 'response.data.error', t('notification.error.unexpected.description', 'Oväntat fel ({{error}})', { error }));
      NotificationManager.error(errorMsg, t('notification.error.unexpected.title', 'Misslyckat'));
      Sentry.captureException(error);
    } finally {
      this.setState({ submittingAd: false });
    }
  };

  submitFeaturedSupplierAd = async (adApplication) => {
    const { t } = this.props;
    this.setState({ submittingAd: true });
    try {
      await serviceAdApplication.updateFeaturedAdApplication(adApplication?._id, {
        featuredInfo: {
          startDate: adApplication?.startDate,
          url: adApplication?.url,
          title: adApplication?.title,
          image: adApplication?.image,
          description: adApplication?.description,
        },
        invoiceInterval: adApplication?.invoiceInterval,
        invoiceEmail: adApplication?.invoiceEmail,
        invoiceRef: adApplication?.invoiceRef,
      });
      this.setState({ showAdModal: false });
      await this.fetchAdApplications({
        status: this.state.filterSearch.adStatus,
        type: this.state.filterSearch.adType,
        search: this.state.filterSearch.searchFilter,
        sort: this.state.filterSearch.order?.[0]?.column ? { column: this.state.filterSearch.order[0].column, order: this.state.filterSearch.order[0].dir } : undefined,
        start: this.state.filterSearch.start,
      });
      NotificationManager.success(
        t('notification.success.submitApplication.description', 'Ansökan har lämnats'),
        t('notification.success.submitApplication.title', 'Ansökt')
      );
    } catch (error) {
      const errorMsg = _.get(error, 'response.data.error', t('notification.error.unexpected.description', 'Oväntat fel ({{error}})', { error }));
      NotificationManager.error(errorMsg, t('notification.error.unexpected.title', 'Misslyckat'));
      Sentry.captureException(error);
    } finally {
      this.setState({ submittingAd: false });
    }
  };

  render() {
    const { selectMode, realArea, currentProject, t } = this.props;
    const {
      data,
      ratingsDropdown,
      areas,
      places,
      isLoading,
      addUpdateSupplier,
      editSupplierData,
      modalAddAreaShown,
      modalAddAreaKey,
      modalAddAreaDataLoading,
      filterSearch,
      selectedSupplierIds,
      contactPersons,
      selectedSuppliers,
      quoteVersionsData,
      extendedDate,
      errorMsg,
      addEditSupplierModalKey,
      selectedTab,
      bulkSelectedSupplierIds,
      bulkBlockedSupplierIds,
      bulkActionRunning,
      showBulkDeleteModal,
      showBulkBlockModal,
      showBulkUnblockModal,
      showBulkCategoriesModal,
      numberOfRecommendedSuppliers,
      showAdNotificationModal,
      showAdModal,
      submittingAd,
      selectedAdIndex,
      showMissingContactPersonsModal,
    } = this.state;

    // Lock the FloatingActionBar while a bulk action is in flight or a bulk modal is open,
    // so actions can't be re-fired or modals stacked. Temporary until step 6 (background jobs).
    const bulkModalOpen = showBulkDeleteModal || showBulkBlockModal || showBulkUnblockModal || showBulkCategoriesModal;
    const isBulkBusy = bulkActionRunning || bulkModalOpen;
    const bulkBusyTooltip = t('bulkActions.runningTooltip', 'Kan inte välja medan en åtgärd körs');

    const quoteVersions = quoteVersionsData[0]?.versions;
    const isFeaturedSupplier = (() => {
      const pathParts = this.props.history?.location?.pathname?.split('/');
      const isFeatured = pathParts?.[3] === 'featured';
      const supplierId = pathParts?.[4];

      return isFeatured && supplierId;
    })()
    const selectedTabName = getSelectedTabName(selectMode, selectedTab, isFeaturedSupplier);
    const onApplicationsTab = [PrequalificationDecision.INBOX, PrequalificationDecision.REJECTED].includes(selectedTabName);

    // Set isChecked for the checkbox inside the detailsPanel
    if (selectedTabName !== TabNames.AD_APPLICATIONS) {
      data.data?.forEach(x => {
        x.isChecked = selectedSupplierIds?.findIndex(s => s === x.sup_id) > -1;
      });
    }

    const supplierApplicationForm = window.location.href.split('/').slice(0, 4).join('/') + '/new-supplier';

    const adApplicationStatusSelectorOptions = Object.entries(this.adStatusText).map(([key, value]) => ({ value: key, label: value }));
    const adApplicationTypeSelectorOptions = Object.entries(this.adTypesText).map(([key, value]) => ({ value: key, label: value }));

    return (
      <AppLayout title={
        selectMode ? (
          <BackButton
            to={this.props.backButtonUrl || `/projects/${currentProject?.slug}${realArea ? ('/' + realArea.value) : ''}`}
            path={[
              currentProject?.name,
              this.props.selectModeTitle
                ?? t('selectMode.pageTitle', 'Lägg till leverantör till {{areaLabel}}', { areaLabel: realArea?.label ?? this.props.areaName ?? '' })
            ]}
          />
        ) : t('pageTitle', 'Leverantörer')
      }>
        <div className="column-content sp-main-container supplier-table-wrapper">
          <TableTopActions
            selectedTab={selectedTab}
            onTabChange={(index) => {
              this.setState({ selectedTab: index, expandedRowId: null }, () => {
                const selectedTabName = getSelectedTabName(selectMode, index, isFeaturedSupplier);

                this.handleChange(0, 'start', true, { // Reset to page 1 when changing tabs
                  ...filterSearch,
                  // Ansökningar hides these filters, so a pick carried over from another tab would filter unseen.
                  ...(selectedTabName === PrequalificationDecision.INBOX && { rating: '', multiFilter: [] }),
                  order: selectedTabName === TabNames.AD_APPLICATIONS ? undefined : [{ column: '0', dir: 'asc' }],
                  searchFilter: selectedTabName === TabNames.AD_APPLICATIONS ? '' : filterSearch.searchFilter
                })
              });
            }}
            onAddArea={!selectMode && this.goToAddAreaPage}
            onSelectMonitoring={!selectMode && this.goToMonitoring}
            onAddSupplier={this.onAddSupplier}
            isReadOnlyUser={appState.isReadOnlyAccessRole()}
            numberOfRecommendedSuppliers={numberOfRecommendedSuppliers}
            selectMode={selectMode}
            isFeaturedSupplier={isFeaturedSupplier}
            inboxCount={appState.getSupplierApplicationCount()}
            onShowSupplierApplicationInfo={() => this.setState({ showSupplierApplicationInfo: true })}
            selectedTabName={selectedTabName}
          />

          {selectedTabName !== TabNames.RECOMMENDED && (
            <SearchBarWithActions className='supplier-database-searchBar-container' value={filterSearch.searchFilter} onChange={(value) => this.search(value)} style={{ marginBottom: '20px' }}>
              {selectedTabName !== TabNames.AD_APPLICATIONS ? (
                <div className="selector-row">
                  <BtChecklistSelect
                    placeholder={t('filter.area.placeholder', 'Yrkeskategori')}
                    {...this.filterChecklist('areaId', areas)}
                  />
                  <CountyMunicipalityChecklist
                    counties={this.state.counties}
                    {...this.countyMunicipalityChecklist()}
                  />
                  <BtChecklistSelect
                    placeholder={t('supplierDetailPanel.profileInfo.places.title', 'Verksamhetsområden')}
                    {...this.filterChecklist('places', places)}
                  />
                  {!onApplicationsTab && (
                    <Selector
                      isClearable
                      isSearchable={false}
                      placeholder={t('filter.rating.placeholder', 'Betyg minst')}
                      options={ratingsDropdown}
                      value={filterSearch.rating ? this.state.ratingsDropdown.find(rd => rd.value == filterSearch.rating) : null}
                      onChange={(e) => this.handleChange(e ? e.value : null, 'rating', true)}
                      filterOption={createFilter({ ignoreAccents: false })}
                    />
                  )}
                  {!onApplicationsTab && (
                    <BtChecklistSelect
                      placeholder={t('filter.multiFilter.placeholder', 'Filter by…')}
                      {...this.filterChecklist('multiFilter', this.multiFilterOptions)}
                    />
                  )}
                  {appState.isSuperAdminOrg() && (
                    <Selector
                      isClearable
                      isSearchable={false}
                      placeholder={t('filter.featured.placeholder', 'Utvald')}
                      options={this.featuredFilterOptions}
                      value={this.featuredFilterOptions.find(x => x.value == filterSearch.featured) ?? null}
                      onChange={(e) => this.handleChange(e ? e.value : null, 'featured', true)}
                    />
                  )}
                  {onApplicationsTab && (
                    <Selector
                      className='sup-db-application-status'
                      isSearchable={false}
                      options={this.applicationStatusOptions}
                      value={this.applicationStatusOptions.find(x => x.value === selectedTab)}
                      onChange={(e) => this.setState({ selectedTab: e.value, expandedRowId: null }, () => this.handleChange(0, 'start', true))}
                    />
                  )}
                </div>
              ) : (
                <div className="selector-row">
                  <Selector
                    isClearable
                    isSearchable={false}
                    placeholder={t('filter.adType.placeholder', 'Typ')}
                    options={adApplicationTypeSelectorOptions}
                    value={filterSearch.adType ? adApplicationTypeSelectorOptions.find(opt => opt.value == filterSearch.adType) : null}
                    onChange={(e) => this.handleChange(e ? e.value : null, 'adType', true)}
                    filterOption={createFilter({ ignoreAccents: false })}
                  />
                  <Selector
                    isClearable
                    isSearchable={false}
                    placeholder={t('filter.adStatus.placeholder', 'Status')}
                    options={adApplicationStatusSelectorOptions}
                    value={filterSearch.adStatus ? adApplicationStatusSelectorOptions.find(opt => opt.value == filterSearch.adStatus) : null}
                    onChange={(e) => this.handleChange(e ? e.value : null, 'adStatus', true)}
                    filterOption={createFilter({ ignoreAccents: false })}
                  />
                </div>
              )}
            </SearchBarWithActions>
          )}

          <div className="supplier-db-main-table-wrap">
            <MaterialTable
              key={selectedTab}
              tableRef={this.tableRef}
              icons={tableIcons}
              isLoading={isLoading}
              options={{
                showSelectAllCheckbox: false,
                detailPanelType: 'single',
                sorting: false,
                draggable: false,
                search: false,
                pageSize: 10,
                pageSizeOptions: [10],
                emptyRowsWhenPaging: false,
                toolbar: false,
                detailPanelColumnStyle: { display: 'none' },
                rowStyle: (rowData) => rowData.isBlacklist ? { color: 'var(--gray-400)' } : {},
                selection: selectMode,
                selectionProps: (rowData) => {
                  const isChecked = !!selectedSupplierIds?.includes(rowData.sup_id);
                  return ({
                    icon: <StyledCheckbox onChange={() => this.onSelectionChange(null, rowData)} checked={isChecked} />,
                    checkedIcon: <StyledCheckbox onChange={() => this.onSelectionChange(null, rowData)} checked={isChecked} />,
                    checked: isChecked,
                    disabled: rowData.isBlacklist,
                    disableRipple: true,
                    style: rowData.isBlacklist ? { display: 'none' } : {}
                  })
                }
              }}
              localization={{ body: { emptyDataSourceMessage: t('table.emptyMessage', 'Kunde inte hitta något resultat') } }}
              columns={this.getColumns(isFeaturedSupplier)}
              data={data.data || []}
              onRowClick={this.handleRowClick}
              onSelectionChange={selectMode ? this.onSelectionChange : undefined}
              detailPanel={rowData => {
                const { selectMode } = this.props;
                if (selectedTabName === TabNames.AD_APPLICATIONS) {
                  return (
                    <AdApplicationDetailPanel
                      key={rowData._id}
                      rowData={rowData}
                      history={this.props.history}
                    />
                  );
                }
                return (
                  <SupplierDetailPanel
                    rowData={rowData}
                    supId={rowData.exists && rowData.existingSupplierId ? rowData.existingSupplierId : rowData.sup_id}
                    key={rowData.sup_id}
                    tableRef={this.tableRef}
                    hasSyna={rowData.hasSyna}
                    hasCreditsafe={rowData.hasCreditsafe}
                    hasTic={rowData.hasTic}
                    selectMode={selectMode}
                    selectedContactPersons={contactPersons}
                    onSelectContactPerson={this.onSelectContactPerson}
                    onSupplierRowUpdate={this.updateSupplierRowFromDetail}
                    renderActions={this.renderActions}
                    checkbox={selectMode && (
                      <StyledCheckbox
                        style={{ marginLeft: '-25px', marginRight: '40px' }}
                        onChange={() => this.onSelectionChange(null, rowData)}
                        checked={rowData.isChecked}
                      />
                    )}
                    onFeaturedSupplierSubmit={(supplierName) => {
                      const tab = appState.isAdminRole() ? 0 : 1;
                      const landsOnApplications = getSelectedTabName(selectMode, tab, isFeaturedSupplier) === PrequalificationDecision.INBOX;
                      this.setState(prev => ({
                        selectedTab: tab,
                        // Ansökningar hides these filters, so a pick carried over from another tab would filter unseen.
                        ...(landsOnApplications && { filterSearch: { ...prev.filterSearch, rating: '', multiFilter: [] } }),
                      }), () => {
                        this.search(supplierName);
                        this.fetchSuppliers()
                      });
                    }}
                    history={this.props.history}
                  />
                );
              }}
              components={{ Pagination: () => null }}
            />
          </div>

          <div className="sup-pagination" style={bulkSelectedSupplierIds.length > 0 && (selectedTab === 0 ? appState.isWriteAccessRole() : appState.isAdminRole()) ? { paddingBottom: '64px' } : undefined}>
            {data.totalCount > 0 && (
              <PaginationWithGoTo
                count={Math.ceil(data.totalCount / 10)}
                onChange={(_, value) => this.onPageChanged(value)}
                page={this.state.currentPage}
                t={i18n.getFixedT(null, 'pagination', 'pagination')}
              />
            )}
          </div>

          {selectMode && (
            <div className="sup-pagination selected-supplier-mod-container">
              <SelectedSupplierModule
                contactPersons={contactPersons}
                quoteVersions={quoteVersions}
                selectedSuppliers={selectedSuppliers}
                onRemoveSupplier={this.onSelectionChange}
                onSelectContactPerson={this.onSelectContactPerson}
                onToggleQuotation={this.onToggleQuotation}
                handleQuoteExpiry={this.handleQuoteExpiry}
                extendedDate={extendedDate}
                checkQuotationExpiry={this.checkQuotationExpiry}
                onSaveSelectedSuppliersClick={this.onSaveSelectedSuppliersClick}
                showLoading={this.props.showLoading}
                errorMsg={errorMsg}
                canRemoveSuppliers={this.props.canRemoveSuppliers}
                saveDisabled={this.props.saveDisabled}
                hideQuotationOptions={this.props.hideQuotationOptions}
                warnMissingContactPersons={this.props.confirmMissingContactPersons}
              />

              <MissingContactPersonsModal
                show={showMissingContactPersonsModal}
                setShow={value => this.setState({ showMissingContactPersonsModal: value })}
                supplierNames={this.suppliersMissingContactPersons().map(sup => sup.sup_name)}
                isSendingBidRequest={this.isSendingBidRequest()}
                isSaving={this.props.showLoading}
                onConfirm={() => {
                  this.setState({ showMissingContactPersonsModal: false });
                  this.props.onSaveSelectedSuppliersClick();
                }}
              />
            </div>
          )}

          {this.state.quickEvaluationSupplier && (
            <QuickEvaluationModal
              supplier={this.state.quickEvaluationSupplier}
              onClose={() => this.setState({ quickEvaluationSupplier: null })}
              onSent={requestId => this.props.history.push(`${appState._getCurrentOrgUrl()}/supplier-database/evaluations/requests/${requestId}`)}
            />
          )}

          <AppAddEditSupplier
            key={'app-add-edit-supplier' + addEditSupplierModalKey}
            show={addUpdateSupplier}
            setShow={(value) => this.setState({ addUpdateSupplier: value })}
            saveSupplier={this.saveSupplier}
            editSupplierData={editSupplierData}
            onModalHide={this.toggleAddSupplierModal}
            fetchNewAreas={this.fetchAreas}
            areas={this.props.areas}
            supplierApplication={false}
            history={this.props.history}
          />

          <BtModal
            center
            name="modal-add-area"
            show={modalAddAreaShown}
            key={'modal-add-area' + modalAddAreaKey}
          >
            <AppAddArea
              handleAddAreaWithSuppliers={this.handleAddAreaWithSuppliers}
              loading={modalAddAreaDataLoading}
              closeModal={() => this.setState({ modalAddAreaShown: false })}
            />
          </BtModal>

          <SupplierAdPopUp
            show={showAdNotificationModal}
            setShow={(value) => this.setState({ showAdNotificationModal: value })}
            areaName={this.props.areaName}
            municipalityName={this.props?.currentProject?.province}
            setTabToRecommended={() => this.setState({ selectedTab: 1 }, () => this.fetchSuppliers())}
            numberOfRecommendedSuppliers={numberOfRecommendedSuppliers}
          />

          <Modal
            title={t('supplierApplicationInfo.heading', 'Ansökningsformulär för nya leverantörer')}
            show={this.state.showSupplierApplicationInfo}
            setShow={(v) => this.setState({ showSupplierApplicationInfo: v })}
            hasCloseButton
          >
            <div style={{ maxWidth: '770px', fontSize: '14px' }}>
              <Trans
                t={t}
                i18nKey="supplierApplicationInfo.description"
                components={{
                  supplierApplicationLink: <a href={supplierApplicationForm} target="_blank" rel="noreferrer">{supplierApplicationForm}</a>
                }}
              />
            </div>
          </Modal>

          <BlockSupplierModal
            key={this.state.blockModal.key}
            show={this.state.blockModal.show}
            onClose={() => this.setState({ blockModal: { ...this.state.blockModal, show: false } })}
            onSuccess={(isBlacklist, reasons) => {
              const supId = this.state.blockModal.rowData.sup_id;
              this.setState(prev => {
                const data = [...prev.data.data];
                const supplier = data.find(d => d.sup_id == supId);
                if (supplier) {
                  supplier.isBlacklist = isBlacklist;
                  supplier.reasons = reasons;
                }
                // A selected row blocked/unblocked here must switch partition bucket too,
                // or the bar keeps offering the action the server would now skip.
                const withoutRow = prev.bulkBlockedSupplierIds.filter(id => id !== supId);
                const bulkBlockedSupplierIds = isBlacklist && prev.bulkSelectedSupplierIds.includes(supId)
                  ? [...withoutRow, supId]
                  : withoutRow;
                const selectedSupplierRows = prev.selectedSupplierRows[supId]
                  ? { ...prev.selectedSupplierRows, [supId]: { ...prev.selectedSupplierRows[supId], isBlacklist, reasons } }
                  : prev.selectedSupplierRows;
                return { ...prev, data: { ...prev.data, data }, bulkBlockedSupplierIds, selectedSupplierRows };
              });
            }}
            supplierId={this.state.blockModal.rowData.sup_id}
            supplierName={this.state.blockModal.rowData.sup_name}
            reasons={this.state.blockModal.rowData.reasons ?? []}
            block={this.state.blockModal.block}
          />

          <Modal
            show={this.state.rejectApplicationModal.show}
            setShow={(value) => this.setState({ rejectApplicationModal: { ...this.state.rejectApplicationModal, show: value } })}
            title={t('rejectApplicationForm.heading', 'Neka leverantörsansökan')}
            buttonInfo={{
              label: t('rejectApplicationForm.button.reject', 'Neka'),
              action: this.confirmRejectApplication,
            }}
          >
            <p>
              <Trans
                t={t}
                i18nKey="rejectApplicationForm.description"
                defaults="Neka leverantörsansökan från <strong>{{name}}</strong>"
                values={{ name: this.state.rejectApplicationModal.supplierName }}
                components={{ strong: <strong /> }}
              />
            </p>
            <Field
              label={t('rejectApplicationForm.label.reason', 'Anledning till nekande')}
              value={this.state.rejectApplicationComment}
              onChange={(value) => this.setState({ rejectApplicationComment: value })}
            />
          </Modal>

          {data?.data?.[selectedAdIndex] && <>
            <AdModal
              show={showAdModal}
              setShow={(value) => this.setState({ showAdModal: value })}
              adApplication={data.data[selectedAdIndex]}
              setAdApplication={(getNewState) => {
                const newData = [...data.data];
                newData[selectedAdIndex] = getNewState(data.data[selectedAdIndex]);
                this.setState({ data: { ...data, data: newData } });
              }}
              submitFeaturedSupplierAd={() => this.submitFeaturedSupplierAd(data.data[selectedAdIndex])}
              submitRecommendedSupplierAd={() => this.submitRecommendedSupplierAd(data.data[selectedAdIndex])}
              submitting={submittingAd}
              setSubmitting={(value) => this.setState({ submittingAd: value })}
              areas={areas.map(x => ({ ...x, id: x.value }))}
              isReviewMode
            />

            <Modal
              show={this.state.rejectionReasonModalVisibility}
              setShow={(value) => this.setState({ rejectionReasonModalVisibility: value })}
              title={t('adApplication.rejectForm.heading', 'Neka ansökan')}
              buttonInfo={{
                label: t('adApplication.rejectForm.button.send', 'Skicka'),
                action: () => {
                  this.setState({ rejectionReasonModalVisibility: false });
                  this.updateAdStatus(data?.data?.[selectedAdIndex]._id, AdApplicationStatus.REJECTED, this.state.rejectionReason);
                }
              }}
            >
              <Field
                label={t('adApplication.rejectForm.label.reason', 'Skriv anledning')}
                value={this.state.rejectionReason}
                onChange={(value) => this.setState({ rejectionReason: value })}
              />
            </Modal>

            <ApproveAdModal
              show={this.state.approveAdModalVisibility}
              setShow={(value) => this.setState({ approveAdModalVisibility: value })}
              onSubmit={() => {
                this.setState({ approveAdModalVisibility: false });
                this.updateAdStatus(data?.data?.[selectedAdIndex]._id, AdApplicationStatus.APPROVED);
              }}
              applicant={data?.data?.[selectedAdIndex].applicant}
              companyName={data?.data?.[selectedAdIndex].companyName}
            />

          </>}

          {!selectMode && selectedTab === 0 && appState.isWriteAccessRole() && (() => {
            // Split the (cross-page aware) selection into blocked vs unblocked so each
            // action targets only the relevant subset of a mixed selection.
            const blockedSelectedIds = bulkSelectedSupplierIds.filter(id => bulkBlockedSupplierIds.includes(id));
            const unblockedSelectedIds = bulkSelectedSupplierIds.filter(id => !bulkBlockedSupplierIds.includes(id));
            const compareCount = bulkSelectedSupplierIds.length;
            const tooMany = compareCount > 10;
            const compareDisabled = isBulkBusy || compareCount < 2 || tooMany;
            return (
              <>
                {/* Hide the action bar while the compare modal is open — it would otherwise
                    overlap the modal's lower rows, and it isn't needed during comparison. */}
                {!this.state.showCompareModal && (
                <FloatingActionBar
                  count={bulkSelectedSupplierIds.length}
                  countLabel={t('bulkActions.selected', 'valda')}
                  onClose={this.clearBulkSelection}
                  disabled={isBulkBusy}
                  disabledTooltip={bulkBusyTooltip}
                  behind={bulkModalOpen}
                >
                  <FloatingActionBarButton
                    icon={<CompareArrowsIcon style={{ fontSize: 16 }} />}
                    label={t('compare.button', 'Jämför')}
                    onClick={this.openCompareModal}
                    disabled={compareDisabled}
                    disabledTooltip={compareCount < 2
                      ? t('compare.selectAtLeastTwo', 'Välj minst två leverantörer att jämföra.')
                      : tooMany
                        ? t('compare.maxTooltip', 'Välj max 10 leverantörer att jämföra.')
                        : bulkBusyTooltip}
                  />
                  <FloatingActionBarDivider />
                  <FloatingActionBarButton
                    icon={<CategoryIcon style={{ fontSize: 16 }} />}
                    label={t('bulkActions.manageCategories', 'Hantera kategorier')}
                    onClick={() => this.setState({ showBulkCategoriesModal: true })}
                    disabled={isBulkBusy}
                    disabledTooltip={bulkBusyTooltip}
                  />
                  {appState.isAdminRole() && unblockedSelectedIds.length > 0 && (
                    <FloatingActionBarButton
                      icon={<BlockIcon style={{ fontSize: 16 }} />}
                      label={t('bulkActions.blockButton', 'Spärra')}
                      onClick={() => this.setState({ showBulkBlockModal: true })}
                      disabled={isBulkBusy}
                      disabledTooltip={bulkBusyTooltip}
                    />
                  )}
                  {appState.isAdminRole() && blockedSelectedIds.length > 0 && (
                    <FloatingActionBarButton
                      icon={<LockOpenIcon style={{ fontSize: 16 }} />}
                      label={t('bulkActions.unblockButton', 'Ta bort spärr')}
                      onClick={() => this.setState({ showBulkUnblockModal: true })}
                      disabled={isBulkBusy}
                      disabledTooltip={bulkBusyTooltip}
                    />
                  )}
                  {appState.isAdminRole() && <FloatingActionBarDivider />}
                  {appState.isAdminRole() && (
                    <FloatingActionBarButton
                      icon={<DeleteOutlineIcon style={{ fontSize: 16 }} />}
                      label={t('bulkActions.delete', 'Ta bort')}
                      onClick={() => this.setState({ showBulkDeleteModal: true })}
                      disabled={isBulkBusy}
                      disabledTooltip={bulkBusyTooltip}
                    />
                  )}
                </FloatingActionBar>
                )}
                <BulkManageCategoriesModal
                  show={this.state.showBulkCategoriesModal}
                  setShow={(v) => this.setState({ showBulkCategoriesModal: v })}
                  areas={areas}
                  supplierIds={bulkSelectedSupplierIds}
                  onSave={this.handleBulkActionComplete}
                  fetchAreas={this.fetchAreas}
                  formatSupplierNames={this.formatSupplierNames}
                />
                <BulkBlockSuppliersModal
                  mode="block"
                  show={this.state.showBulkBlockModal}
                  setShow={(v) => this.setState({ showBulkBlockModal: v })}
                  supplierIds={unblockedSelectedIds}
                  onSave={this.handleBulkActionComplete}
                  formatSupplierNames={this.formatSupplierNames}
                />
                <BulkBlockSuppliersModal
                  mode="unblock"
                  show={this.state.showBulkUnblockModal}
                  setShow={(v) => this.setState({ showBulkUnblockModal: v })}
                  supplierIds={blockedSelectedIds}
                  onSave={this.handleBulkActionComplete}
                  formatSupplierNames={this.formatSupplierNames}
                />
                <BulkDeleteSuppliersModal
                  show={this.state.showBulkDeleteModal}
                  setShow={(v) => this.setState({ showBulkDeleteModal: v })}
                  supplierIds={bulkSelectedSupplierIds}
                  onSave={this.handleBulkActionComplete}
                  formatSupplierNames={this.formatSupplierNames}
                />
                <CompareSuppliersModal
                  show={this.state.showCompareModal}
                  setShow={this.setShowCompareModal}
                  suppliers={this.state.compareRows}
                  cities={this.state.cities}
                />
              </>
            );
          })()}

          {!selectMode && selectedTab === 1 && appState.isAdminRole() && (
            <FloatingActionBar
              count={bulkSelectedSupplierIds.length}
              countLabel={t('bulkActions.selected', 'valda')}
              onClose={this.clearBulkSelection}
              disabled={isBulkBusy}
              disabledTooltip={bulkBusyTooltip}
            >
              <FloatingActionBarButton
                icon={<CheckIcon style={{ fontSize: 16 }} />}
                label={t('bulkActions.approve.label', 'Godkänn')}
                onClick={this.handleBulkApprove}
                disabled={isBulkBusy}
                disabledTooltip={bulkBusyTooltip}
              />
              <FloatingActionBarDivider />
              <FloatingActionBarButton
                icon={<CloseIcon style={{ fontSize: 16 }} />}
                label={t('bulkActions.reject.label', 'Neka')}
                onClick={this.handleBulkReject}
                disabled={isBulkBusy}
                disabledTooltip={bulkBusyTooltip}
              />
            </FloatingActionBar>
          )}

          {!selectMode && selectedTab === 2 && appState.isAdminRole() && (
            <FloatingActionBar
              count={bulkSelectedSupplierIds.length}
              countLabel={t('bulkActions.selected', 'valda')}
              onClose={this.clearBulkSelection}
              disabled={isBulkBusy}
              disabledTooltip={bulkBusyTooltip}
            >
              <FloatingActionBarButton
                icon={<ReplayIcon style={{ fontSize: 16 }} />}
                label={t('bulkActions.reprocess.label', 'Gör om ansökan')}
                onClick={this.handleBulkReprocess}
                disabled={isBulkBusy}
                disabledTooltip={bulkBusyTooltip}
              />
            </FloatingActionBar>
          )}
        </div>
      </AppLayout>
    );
  }
}

export default withTranslation(['supplierDatabase', 'evaluations'], { withRef: true })(SupplierDatabase);
